import React, { Component } from 'react';
import { Switch, Route, NavLink, Redirect } from 'react-router-dom';
import Page from '../../components/Page';
import { Menu, Icon, Popup, Button, Radio, Modal, Checkbox } from 'semantic-ui-react';
import Picker from '../../components/DateRangePicker';
import moment from 'moment';
import _ from 'lodash';
// eslint-disable-next-line
import { connect } from 'react-redux';
import { withTranslation } from 'react-i18next';
import 'moment/min/locales';

import Agent from './agent';
import Selling from './selling';
import Order from './order';
import OrderCollectaction from './order_collectaction';
import Closed from './closedtag';
import ClosedFrequency from './closeFrequency';
import Time from './time';
import SendingProduct from './sendingproduct';
import Dashboard from './dashboard';
import Template from './template';
import ConversationGroup from './conversationgroup';
import Timeline from './timeline';
import UserList from './userlist';
import StockInfo from './stockinfo';
import EventTable from './event';
import RatesList from './rateslist';
import RatesComments from './rate_comments';
import GeneralAgentTable from './generalTable';
import MissingConversationTable from './missingConversations';
import SellingCollectaction from './selling_collectaction';
import ArchiveTab from './archive';
import SendMailTab from './sendMail';
import IntentForward from './intentForward';
import BotConversations from './bot_conversations';
import AgentStatusTimeline from './timelineagentstatus';
import LastMessageDifference from './lastMessageDifference';
import AgentStatusCurrent from './agentstatuscurrent';
import AgentAutoCheck from './agentautocheck';
import RawAnalytic from './rawanalytics';
import { get, post } from '../../util/api';
import { th } from 'date-fns/locale';
//import Randevu from './randevu';

function formatMinutesToTime(minutes, product) {
	minutes = (minutes / 1000 / 60).toFixed(2);
	if (!product.showformat) return minutes;
	const totalSeconds = Math.round(minutes * 60);

	const hours = Math.floor(totalSeconds / 3600);
	const remainingSeconds = totalSeconds % 3600;
	const minutesPart = Math.floor(remainingSeconds / 60);
	const secondsPart = remainingSeconds % 60;

	const formattedHours = String(hours).padStart(2, '0');
	const formattedMinutes = String(minutesPart).padStart(2, '0');
	const formattedSeconds = String(secondsPart).padStart(2, '0');

	return `${formattedHours}:${formattedMinutes}:${formattedSeconds}`;
}
class Analytic extends Component {
	state = {
		loading: true,
		ecommerce: false,
		sendProduct: false,
		conversationGroup: false,
		pid: /* '1e00a47c670273a623c13c54dba44006' ||  */ /* '02cc63330cd0808f87c54ad9dd94b74a' || */ this.props.product.live.settings.live.token,
		start_date:
			this.props.product && this.props.product.live && this.props.product.live.settings && this.props.product.live.settings.noMinDate
				? moment('01-01-2022').startOf('day')
				: moment().subtract(7, 'day').startOf('day'),
		agent_role: this.props.access.user.loggedUserObj.role,
		end_date:
			this.props.product && this.props.product.live && this.props.product.live.settings && this.props.product.live.settings.noMinDate
				? moment('05-31-2022').endOf('day')
				: moment().subtract(1, 'day').endOf('day'),
		start_time: moment().startOf('day'),
		end_time: moment().endOf('day'),
		today: moment(),
		closedExcelData: [],
		agentExcelData: [],
		buttonLoading: false,
		displayName: 'developer',
		rateList: [],
		allClosedData: [],
		selectedPlatform: 'all',
		productSettings: this.props.product.live.settings,
		allpage: false,
		openPopup: false,
	};
	componentDidMount() {
		fetch('/api/live/agent/list')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ newList: data.agents });
			});
		fetch('/api/dahi/message/getLiveChat', {})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					data: data.result,
					productAgentList:
						data.result &&
						data.result.agents &&
						_.filter(data.result.agents, function (it) {
							return it.type !== 'viewer';
						}),
					productOldAgentList: data.result && data.result.old_agents,
					loading: false,
					agent_statuses: data.result && data.result.staticOptions && data.result.staticOptions.agent_statuses,
					closeTags: data.result && data.result.staticOptions && data.result.staticOptions.closeTags,
				});
			});
	}
	dateChange = ({ selection }) => {
		let start_date = moment(selection.startDate).startOf('day');
		let end_date = moment(selection.endDate);
		if (end_date.format('YYYY-MM-DD') !== this.state.today.format('YYYY-MM-DD')) {
			end_date = end_date.endOf('day');
		} else {
			end_date = moment();
		}
		this.setState({ start_date, end_date });
	};
	timeChangeStart = (value) => {
		let { start_date } = this.state;
		start_date = moment(start_date).set({ hour: moment(value, 'HH:mm').format('HH'), minute: moment('00', 'mm').format('mm') });
		this.setState({ start_date });
	};
	timeChangeEnd = (value) => {
		let { end_date } = this.state;
		end_date = moment(end_date).set({ hour: moment(value, 'HH:mm').format('HH'), minute: moment('59', 'mm').format('mm') });
		this.setState({ end_date });
	};
	toggleName = () => this.setState({ displayName: this.state.displayName === 'developer' ? 'name' : 'developer' });
	async createExcelData(productAgentList, t, productOldAgentList, onePage = false) {
		let product = this.props.product.live;
		let ecommerce,
			sendProduct,
			conversationGroup,
			showTemplate,
			generalTable,
			stockinfo,
			ratePoint,
			rateComment,
			allConversationTable,
			orderCollectaction,
			forwardIntent,
			botConversations;
		//timeline = true;
		if (product.settings.analyticView) {
			ecommerce = product.settings.analyticView.ecommerce;
			sendProduct = product.settings.analyticView.sendProduct;
			conversationGroup = product.settings.analyticView.conversationGroup;
			showTemplate = product.settings.analyticView.showTemplate;
			generalTable = product.settings.analyticView.generalTable;
			stockinfo = product.settings.analyticView.stockinfo;
			//timeline = product.settings.analyticView.timeline;
			//userlist = product.settings.analyticView.userlist;
			ratePoint = product.settings.analyticView.ratePoint;
			rateComment = product.settings.analyticView.rateComment;
			allConversationTable = false; // product.settings.analyticView.allConversationTable;
			orderCollectaction = product.settings.analyticView.orderCollectaction;
			forwardIntent = product.settings.analyticView.forwardIntent;
			botConversations = product.settings.analyticView.botConversations;
		}
		this.setState({ buttonLoading: true });
		let path = window.location.pathname.replace('/analytic/', '');
		let pages = [
			{ name: 'agent' },
			{ name: 'time' },
			{ name: 'missingconversations' },
			{ name: 'closedtag' },
			{ name: 'rateslist' },
			{ name: 'timeline' },
			{ name: 'selling' },
			{ name: 'order' },
			{ name: 'sendingproduct' },
			{ name: 'order_collectaction' },
			{ name: 'selling_collectaction' },
			{ name: 'stockinfo' },
			{ name: 'eventtable' },
			{ name: 'dashboard' },
		];
		if (!onePage || (onePage && /agent|closedtag|rateslist|ratescomments|closedgenaral/.test(path)))
			await this.getClosedData(productAgentList, productOldAgentList);
		if (!onePage || (onePage && /agent|closedtag|rateslist|ratescomments|closedgenaral/.test(path))) await this.getClosedFrequency();
		if (!onePage || (onePage && /agent|closedtag|rateslist|ratescomments|closedgenaral/.test(path)))
			await this.getAgentData(productAgentList, productOldAgentList);
		if (!onePage || (onePage && /agent|closedtag|rateslist|ratescomments|closedgenaral/.test(path))) await this.getClosedDataTopic();
		if (ratePoint || allConversationTable || rateComment) {
			if (!onePage || (onePage && /agent|closedtag|rateslist|ratescomments|closedgenaral/.test(path))) await this.getRateList(productAgentList);
		}
		if (sendProduct) {
			if (!onePage || (onePage && /sendingproduct/.test(path))) await this.getSendingProduct();
		}
		if (!onePage || (onePage && /time|timeline/.test(path))) await this.getTimeData(productAgentList);
		if (!onePage || (onePage && /time|timeline/.test(path))) await this.getAllTimeData();
		if (!onePage || (onePage && /lastmessagedifference/.test(path))) await this.getLastMessageDifferenceTimeData(productAgentList);
		if (!onePage || (onePage && /lastmessagedifference/.test(path))) await this.getAllLastMessageDifferenceTimeData(productAgentList);
		if (forwardIntent) {
			if (!onePage || (onePage && /intentforward|intentforward/.test(path))) await this.getIntents();
			if (!onePage || (onePage && /intentforward|intentforward/.test(path))) await this.getIntentData();
		}
		if (generalTable) {
			if (!onePage || (onePage && /dashboard/.test(path))) await this.getGeneralTableData();
			if (!onePage || (onePage && /dashboard/.test(path))) await this.getGeneralGraph();
			if (!onePage || (onePage && /dashboard|missingconversations/.test(path))) await this.getMissingConversationTable();
			/* if (!onePage || (onePage && /dashboard/.test(path))) await this.getAgentTimeLine(productAgentList); */
		}
		if (orderCollectaction) {
			if (!onePage || (onePage && /order_collectaction|selling_collectaction/.test(path))) await this.getSellingCollectaction(productAgentList);
			if (!onePage || (onePage && /order_collectaction|selling_collectaction/.test(path))) await this.getOrderCollectaction();
		}
		if (ecommerce) {
			if (!onePage || (onePage && /order|selling/.test(path))) await this.getSellingData(productAgentList);
		}
		if (ecommerce) {
			if (!onePage || (onePage && /order|selling/.test(path))) await this.getOrderData();
			if (!onePage || (onePage && /order|selling/.test(path))) await this.getForgettenBaskets();
		}
		if (showTemplate) {
			await this.getTemplateData();
		}
		if (conversationGroup) {
			await this.getConversationData();
		}
		if (stockinfo) {
			await this.getStockInfo();
		}
		if (botConversations) {
			if (!onePage || (onePage && /botconversations/.test(path))) await this.getBotConversation(productAgentList);
		}

		this.exportExcel(t, onePage, path);
	}
	async createExcelDataHourly(productAgentList, t, productOldAgentList, onePage = false) {
		let product = this.props.product.live;
		let ecommerce,
			sendProduct,
			conversationGroup,
			showTemplate,
			generalTable,
			stockinfo,
			ratePoint,
			rateComment,
			allConversationTable,
			orderCollectaction,
			forwardIntent,
			botConversations;
		//timeline = true;
		if (product.settings.analyticView) {
			ecommerce = product.settings.analyticView.ecommerce;
			sendProduct = product.settings.analyticView.sendProduct;
			conversationGroup = product.settings.analyticView.conversationGroup;
			showTemplate = product.settings.analyticView.showTemplate;
			generalTable = product.settings.analyticView.generalTable;
			stockinfo = product.settings.analyticView.stockinfo;
			//timeline = product.settings.analyticView.timeline;
			//userlist = product.settings.analyticView.userlist;
			ratePoint = product.settings.analyticView.ratePoint;
			rateComment = product.settings.analyticView.rateComment;
			allConversationTable = false; // product.settings.analyticView.allConversationTable;
			orderCollectaction = product.settings.analyticView.orderCollectaction;
			forwardIntent = product.settings.analyticView.forwardIntent;
			botConversations = product.settings.analyticView.botConversations;
		}
		this.setState({ buttonLoading: true });
		let path = window.location.pathname.replace('/analytic/', '');
		let pages = [
			{ name: 'agent' },
			{ name: 'time' },
			{ name: 'missingconversations' },
			{ name: 'closedtag' },
			{ name: 'rateslist' },
			{ name: 'timeline' },
			{ name: 'selling' },
			{ name: 'order' },
			{ name: 'sendingproduct' },
			{ name: 'order_collectaction' },
			{ name: 'selling_collectaction' },
			{ name: 'stockinfo' },
			{ name: 'eventtable' },
			{ name: 'dashboard' },
		];
		if (generalTable) {
			await this.getGeneralTableData();
			await this.getGeneralGraph();
			await this.getMissingConversationTable();
			/*  await this.getAgentTimeLine(productAgentList); */
		}

		this.exportExcelHourly(t, false, path);
	}
	async getAgentData(productAgentList, productOldAgentList) {
		let { start_date, end_date, pid } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let agentExcelData = productAgentList;
		let othersdata = {
			closed: 0,
			contacted: 0,
			developer: 'others',
			name: 'others',
			id: 'others',
			key: 'others',
			taken: 0,
			text: 'others',
			value: 'others',
			viewed: 0,
			forwarded: 0,
		};
		let agentData = await fetch('https://log.yapaytech.com/live/test/getInfo?ssssss1', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['viewed', 'taken', 'contacted', 'closed', 'forwarded'],
					pid: pid,
				},
				select: '',
				group: ['type', 'agent'],
				pairs: { agent: 'select1' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		_.map(agentData, (it) => {
			var e = _.findIndex(agentExcelData, function (o) {
				return o.id === it.agent;
			});
			/* if (e < 0 && /bot/.test(it.agent)) return agentExcelData.push({ id: it.agent, developer: 'Bot' }); */

			if (e >= 0) return (agentExcelData[e][it.type] = it.count);
			else if (/bot/.test(it.agent) || it.agent === pid) {
				//console.log('bot');
			} else {
				if (/yapaytech/.test(it.key)) {
					if (productOldAgentList && productOldAgentList.length) {
						let oldAgent = _.find(productOldAgentList, { id: it.agent });
						if (oldAgent) {
							var e = _.findIndex(agentExcelData, function (o) {
								return o.id === it.agent;
							});
							if (e >= 0) return (agentExcelData[e][it.type] = it.count);
							else return agentExcelData.push({ name: oldAgent.fullname, developer: oldAgent.developer, id: it.agent, [it.type]: it.count });
						} else {
							othersdata[it.type] = othersdata[it.type] + it.count;
						}
					} else {
						othersdata[it.type] = othersdata[it.type] + it.count;
					}
				}
			}
		});

		_.map(agentExcelData, (it) => {
			_.map(['viewed', 'taken', 'contacted', 'closed', 'forwarded'], (d) => {
				if (it && !it[d]) {
					it[d] = 0;
				}
			});
			it.name = _.find(this.state.newList, { email: it.developer }) && _.find(this.state.newList, { email: it.developer }).name;
		});
		//console.log('agentExcelData', agentExcelData);
		/* _.map(agentData, (it) => {
			var e = _.findIndex(agentExcelData, function (o) {
				return o.id === it.agent;
			});
			agentExcelData[e][it.type] = it.count;
		}); */
		agentExcelData.push(othersdata);
		this.setState({ agentExcelData });
	}

	async getClosedData(productAgentList, productOldAgentList) {
		let { start_date, end_date, pid, closeTags } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let closedExcelData = productAgentList;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let closedData = await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['closed'],
					pid: pid,
				},
				select: '',
				group: ['type', 'agent', 'rate'],
				pairs: { agent: 'select1', topic: 'select2', rate: 'select5' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return _.filter(response.result, (it) => it.agent !== pid);
			});
		let ng = _.map(closedData, function (it) {
			return {
				count: it.count,
				type: it.type,
				agent: it.agent,
				topic: it.topic,
				rate: parseInt(it.rate) || 0,
				total: it.count * (parseInt(it.rate) || 0),
			};
		});
		let groupAgentData = _.groupBy(ng, 'agent');
		_.map(closedExcelData, function (it) {
			return _.assign(it, { count: 0, ratedCount: 0, avgRate: 0, rates_one: 0, rates_two: 0, rates_three: 0, rates_four: 0, rates_five: 0 });
		});
		let newData = [];

		newData = _.map(groupAgentData, function (it) {
			return {
				count: _.sumBy(it, 'count'),
				type: it[0].type,
				agent: it[0].agent,
				topic: (_.find(closeTags, { id: it[0].topic }) && _.find(closeTags, { id: it[0].topic }).title) || it[0].topic,
				ratedCount: _.sumBy(
					_.filter(it, function (o) {
						return o.rate > 0;
					}),
					'count'
				),
				total: _.sumBy(it, 'total'),
				avgRate:
					(
						_.sumBy(
							_.filter(it, function (o) {
								return o.rate > 0;
							}),
							'count'
						) &&
						_.sumBy(it, 'total') /
							_.sumBy(
								_.filter(it, function (o) {
									return o.rate > 0;
								}),
								'count'
							)
					).toFixed(2) || 0,
				rates_one: _.sumBy(
					_.filter(it, (o) => o.rate === 1),
					'count'
				),
				rates_two: _.sumBy(
					_.filter(it, (o) => o.rate === 2),
					'count'
				),
				rates_three: _.sumBy(
					_.filter(it, (o) => o.rate === 3),
					'count'
				),
				rates_four: _.sumBy(
					_.filter(it, (o) => o.rate === 4),
					'count'
				),
				rates_five: _.sumBy(
					_.filter(it, (o) => o.rate === 5),
					'count'
				),
			};
		});
		//console.log('newData', newData);
		_.map(newData, function (it) {
			var e = _.findIndex(closedExcelData, function (o) {
				return o.id === it.agent;
			});
			if (e >= 0)
				return _.assign(closedExcelData[e], {
					count: it.count,
					ratedCount: it.ratedCount,
					avgRate: it.avgRate,
					total: it.total,
					rates_one: it.rates_one,
					rates_two: it.rates_two,
					rates_three: it.rates_three,
					rates_four: it.rates_four,
					rates_five: it.rates_five,
				});
			else {
				let old_agent = _.find(productOldAgentList, { id: it.agent });
				if (old_agent) {
					closedExcelData.push({
						id: it.agent,
						name: old_agent.fullname,
						developer: old_agent.developer,
						count: it.count,
						ratedCount: it.ratedCount,
						avgRate: it.avgRate,
						total: it.total,
						rates_one: it.rates_one,
						rates_two: it.rates_two,
						rates_three: it.rates_three,
						rates_four: it.rates_four,
						rates_five: it.rates_five,
					});
				}
			}
		});
		this.setState({ closedExcelData });
	}
	async getRateList(productAgentList) {
		let { start_date, end_date, pid, closeTags } = this.state;
		//console.log('closeTags', closeTags, productAgentList);
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();

		let closedData = await fetch('https://log.yapaytech.com/live/test/getInfo?closed', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['closed', 'agentChatTime'],
					pid: pid,
				},
				select: '',
				group: ['type', 'agent', 'rate', 'cid', 'date', 'platform', 'topic', 'comment', 'selectable_comment'],
				pairs: {
					agent: 'select1',
					topic: 'select2',
					cid: 'select4',
					rate: 'select5',
					platform: 'platform',
					comment: 'select7',
					selectable_comment: 'select3',
				},
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result; //_.filter(response.result, (it) => it.agent !== pid);
			});
		let only_closed = _.filter(closedData, { type: 'closed' });
		let only_time = _.filter(closedData, { type: 'agentChatTime' });
		//console.log('agentChatTime', only_closed);
		let filterData = _.filter(only_closed, (o) => o.rate);

		/* let allClosedData = _.map(only_closed, (o) => {
			let agent = _.find(productAgentList, { id: o.agent });
			let topic = _.find(closeTags, { id: o.topic });
			let agentTime = _.find(only_time, { cid: o.cid, agent: o.agent });
			//console.log('agentChatTime', agentTime);
			let sumTime = agentTime && agentTime.sum && moment.duration(agentTime.sum);
			return {
				agent: (agent && agent.developer) || o.agent,
				name: (agent && agent.name) || '',
				count: o.count,
				date: moment(o.date).format('DD-MM-YYYY'),
				len: o.len,
				platform: pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && o.platform === 'web' ? 'flo' : o.platform,
				rate: o.rate,
				topic: (topic && topic.title) || o.topic,
				cid: o.cid,
				agentTime: (sumTime && this.formatTime(sumTime)) || '-',
				agentTimeMin: parseFloat((sumTime / 1000 / 60).toFixed(2)),
			};
		}); */

		let groupedRateList = _.orderBy(
			_.map(
				_.groupBy(filterData, (it) => '' + it.rate),
				(o) => ({
					rate: o[0].rate,
					length: o.length,
					rates: _.map(
						_.groupBy(o, (e) => e.selectable_comment),
						(t) => ({ comment: t[0].selectable_comment, length: t.length })
					),
				})
			),
			(j) => _.parseInt(j.rate),
			'desc'
		);
		let excelgroupedRateList = [];
		_.map(groupedRateList, (it) => {
			excelgroupedRateList.push({ name: `${it.rate} - Toplam`, count: it.length });
			_.map(it.rates, (o) => {
				excelgroupedRateList.push({ name: `-${it.rate} - ${o.comment || 'Boş'}`, count: o.length });
			});
		});
		let rateList = _.map(filterData, function (o) {
			let agent = _.find(productAgentList, { id: o.agent });
			let topic = _.find(closeTags, { id: o.topic });
			return {
				agent: (agent && agent.developer) || o.agent,
				name: (agent && agent.name) || '',
				count: o.count,
				date: moment(o.date).format('DD-MM-YYYY'),
				len: o.len,
				platform: pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && o.platform === 'web' ? 'flo' : o.platform,
				rate: o.rate,
				topic: (topic && topic.title) || o.topic,
				cid: o.cid,
				comment: o.comment,
				selectable_comment: o.selectable_comment,
			};
		});
		this.setState({ rateList, excelgroupedRateList });
	}
	async getClosedDataTopic() {
		let { start_date, end_date, pid, closeTags } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		//let closedExcelData = productAgentList;
		let closedData = await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['closed'],
					pid: pid,
				},
				select: '',
				group: ['type', 'topic', 'rate'],
				pairs: { agent: 'select1', topic: 'select2', rate: 'select5' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result; //_.filter(response.result, (it) => it.topic !== 'auto_close');
			});
		let ng = _.map(closedData, function (it) {
			return {
				count: it.count,
				type: it.type,
				agent: it.agent,
				topic: it.topic,
				rate: parseInt(it.rate) || 0,
				total: it.count * (parseInt(it.rate) || 0),
			};
		});
		let groupAgentData = _.groupBy(ng, 'topic');
		/* _.map(closedExcelData, function (it) {
			return _.assign(it, { count: 0, ratedCount: 0, avgRate: 0 });
		}); */
		let newData = [];

		newData = _.map(groupAgentData, function (it) {
			return {
				count: _.sumBy(it, 'count'),
				type: it[0].type,
				agent: it[0].agent,
				topic: (_.find(closeTags, { id: it[0].topic }) && _.find(closeTags, { id: it[0].topic }).title) || it[0].topic,
				ratedCount: _.sumBy(
					_.filter(it, function (o) {
						return o.rate > 0;
					}),
					'count'
				),
				total: _.sumBy(it, 'total'),
				avgRate:
					(
						_.sumBy(
							_.filter(it, function (o) {
								return o.rate > 0;
							}),
							'count'
						) &&
						_.sumBy(it, 'total') /
							_.sumBy(
								_.filter(it, function (o) {
									return o.rate > 0;
								}),
								'count'
							)
					).toFixed(2) || 0,

				rates_one: _.sumBy(
					_.filter(it, (o) => o.rate === 1),
					'count'
				),
				rates_two: _.sumBy(
					_.filter(it, (o) => o.rate === 2),
					'count'
				),
				rates_three: _.sumBy(
					_.filter(it, (o) => o.rate === 3),
					'count'
				),
				rates_four: _.sumBy(
					_.filter(it, (o) => o.rate === 4),
					'count'
				),
				rates_five: _.sumBy(
					_.filter(it, (o) => o.rate === 5),
					'count'
				),
			};
		});

		this.setState({ closedTopicData: newData });
	}
	async getMissingConversationTable() {
		try {
			let { start_date, end_date } = this.state;
			start_date = moment(start_date).format();
			end_date = moment(end_date).format();

			// Paralel veri çekme
			const [contactedData, waitingData] = await Promise.all([
				// Bağlanılan konuşmalar (contacted)
				fetch('https://log.yapaytech.com/live/test/getInfo?contacted', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						start_date,
						end_date,
						include_hour: true,
						filter: {
							type: ['contacted'],
							pid: this.state.pid,
						},
						select: [],
						group: ['type', 'cid', 'platform'],
						pairs: { agent: 'type1', cid: 'select2', platform: 'platform' },
						options: { cids: 'count(distinct select2)' },
					}),
				})
					.then((response) => response.json())
					.then((data) => data?.result || []),

				// Bekleyen ve activateAgent olan konuşmalar
				fetch('https://log.yapaytech.com/live/getWaitingInfo1', {
					method: 'POST',
					headers: { 'Content-Type': 'application/json' },
					body: JSON.stringify({
						start_date: moment(start_date).valueOf(),
						end_date: moment(end_date).valueOf(),
						pid: this.state.pid,
						select: '*',
					}),
				})
					.then((response) => response.json())
					.then((data) => data?.result?.result || []),
			]);

			// Bekleyenleri işle - chunk'lara bölerek
			const CHUNK_SIZE = 1000;
			const chunks = _.chunk(waitingData, CHUNK_SIZE);
			let activateAgentConversations = [];

			for (const chunk of chunks) {
				const processed = chunk.map((it) => {
					const selected = _.find(it, { label: 'activateAgent' }) || it[0];
					return {
						cid: selected.cid,
						created_at: selected.created_at,
						platform: selected.platform,
					};
				});
				activateAgentConversations.push(...processed);
				await new Promise((resolve) => setTimeout(resolve, 0));
			}

			// contacted olmayan konuşmaları bul
			let missingConversations = _.differenceBy(activateAgentConversations, contactedData, 'cid');

			// Sonuç formatı
			const formattedMissing = missingConversations.map((it) => ({
				cid: it.cid,
				date: moment(it.created_at).format('DD-MM-YYYY HH:mm:ss'),
				platform: this.state.pid === '8246c490-2e1c-11eb-ad5c-b51ab8880cfc' && it.platform === 'web' ? 'flo' : it.platform,
			}));

			this.setState({
				missing_list: formattedMissing,
				getWaitingInfo1Data: activateAgentConversations,
				missingCount: formattedMissing.length,
			});
		} catch (error) {
			console.error('Error in getMissingConversationTable:', error);
			this.setState({ missing_list: [], getWaitingInfo1Data: [], missingCount: 0 });
		}
	}
	async getGeneralTableData() {
		let { start_date, end_date, pid } = this.state;
		let start_date_1 = moment(start_date).format();
		let end_date_1 = moment(end_date).format();
		/* await fetch('https://live.dahi.ai/analytics/dialogtab/uniqueUserCountsByMessage', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					loadinguniqueUsers: false,
					uniqueUsers: data && data.data,
				});
			}); */
		await fetch('https://log.yapaytech.com/live/getEventInfoGeneral?filtertest', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					label: 'activateAgent',
					pid: this.state.pid,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					loadingTotalWaitingConv: false,
					totalWaitingConv: data.result.total,
				});
			});
		fetch('https://log.yapaytech.com/live/getEventInfoGeneral', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					pid: this.state.pid,
				},
				labels: ['opened'],
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let opened_list = _.filter(data.result.result, { label: 'opened' });
				this.setState({
					totalOpenedConvHourly: opened_list,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: {
					type: ['contacted'],
					pid: this.state.pid,
				},
				select: [],
				group: ['type'],
				pairs: { agent: 'type1' },
				options: {
					cids: 'count(distinct select2)',
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					contactedData: (data && data.result && data.result[0] && data.result[0].cids && parseInt(data.result[0].cids)) || 0,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?closeddata', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['closed'], pid: this.state.pid },
				select: [],
				group: ['type', 'agent'],
				pairs: { agent: 'select1' },
				options: {},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let filter = _.filter(data.result, function (it) {
					return it.agent !== '5e6f519560b2b4d07559fcf8';
				});
				let onlyAgentCounts = _.filter(data.result, function (it) {
					return it.agent !== pid;
				});

				this.setState({
					totalClosedData: _.sumBy(filter, 'count') || 0,
					totalAgentClosedData: _.sumBy(onlyAgentCounts, 'count'),
				});
			});
	}

	async getTimeData(productAgentList) {
		let { start_date, end_date, productSettings } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let timeExcelData = productAgentList;
		let timeData = await fetch('https://log.yapaytech.com/live/test/getInfo?agentChatTime', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['agentChatTime', 'chatTimeAfterActivate', 'agentFirstResponseTimeAfterActivate', 'agentFirstResponseTime'],
					pid: this.state.pid,
				},
				select: '',
				group: ['type', 'agent'],
				pairs: { agent: 'select1', topic: 'select2' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		/* let timeDataDate = await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				filter: { type: ['agentChatTime', 'chatTimeAfterActivate', 'agentFirstResponseTimeAfterActivate'], pid: this.state.pid },
				select: '',
				group: ['type', 'day'],
				pairs: { agent: 'select1', topic: 'select2' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		let timeDataDateExcel = _.map(timeDataDate, function (it) {
			return _.merge(it, {
				dayNumber: moment(it.day).dayOfYear(),
			});
		});
		timeDataDateExcel = _.groupBy(timeDataDateExcel, 'type');
		let agentChatTimeData = timeDataDateExcel.agentChatTime;
		let agentFirstResponseTimeAfterActivateData = timeDataDateExcel.agentFirstResponseTimeAfterActivate;
		let chatTimeAfterActivateData = timeDataDateExcel.chatTimeAfterActivate;
		let timeDataDateExcelL = _.map(agentChatTimeData, function (it, i) {
			_.merge(it, { agentChatTime: it.avg });
		});
		//console.log('data', timeDataDateExcel); */
		let othersdata = {
			agentChatTime: 0,
			chatTimeAfterActivate: 0,
			developer: 'others',
			name: 'others',
			id: 'others',
			key: 'others',
			agentFirstResponseTimeAfterActivate: 0,
			agentFirstResponseTime: 0,
			text: 'others',
			value: 'others',
		};
		_.map(timeData, (it) => {
			var e = _.findIndex(timeExcelData, function (o) {
				return o.id === it.agent;
			});
			let avgMo = it.avg;
			/* if (e < 0 && /bot/.test(it.agent)) return timeExcelData.push({ id: it.agent, developer: 'Bot' }); */
			if (e >= 0) {
				let value = productSettings.showformat ? this.formatTime(avgMo) : it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2));
				return (timeExcelData[e][it.type] = value);
			}
			//this.formatTime(avgMo));
			else if (/bot/.test(it.agent) || it.agent === this.state.pid) {
				//console.log('bot');
			} else {
				let value = productSettings.showformat ? this.formatTime(avgMo) : it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2));
				othersdata[it.type] = value; //this.formatTime(avgMo);
			}

			/* if (e >= 0) return (timeExcelData[e][it.type] = it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2))); */
		});
		_.map(timeExcelData, (it) => {
			_.map(['agentChatTime', 'chatTimeAfterActivate', 'agentFirstResponseTimeAfterActivate', 'agentFirstResponseTime'], (d) => {
				if (it && !it[d]) {
					it[d] = 0;
				}
			});
		});
		let oagent = _.find(timeExcelData, { developer: 'others' });
		if (oagent) {
			_.assign(oagent, othersdata);
		} else {
			timeExcelData.push(othersdata);
		}
		this.setState({ timeExcelData });
	}

	async getLastMessageDifferenceTimeData(productAgentList) {
		let { start_date, end_date, productSettings } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let timeExcelData = productAgentList;
		let timeData = await fetch('https://log.yapaytech.com/live/test/getInfo?lastmessage_difference', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['lastmessage_difference'],
					pid: this.state.pid,
					user_type: 'agent',
				},
				select: '',
				group: ['type', 'agent'],
				pairs: { agent: 'select1', topic: 'select2', user_type: 'select4' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});

		let othersdata = {
			lastmessage_difference: 0,
			developer: 'others',
			name: 'others',
			id: 'others',
			key: 'others',
			text: 'others',
			value: 'others',
		};
		_.map(timeData, (it) => {
			var e = _.findIndex(timeExcelData, function (o) {
				return o.id === it.agent;
			});
			let avgMo = it.avg;
			let sumMo = it.sum;
			/* if (e < 0 && /bot/.test(it.agent)) return timeExcelData.push({ id: it.agent, developer: 'Bot' }); */
			if (e >= 0) {
				let value = formatMinutesToTime(avgMo, productSettings);
				let valueSum = formatMinutesToTime(sumMo, productSettings);
				timeExcelData[e][it.type] = value;
				timeExcelData[e][it.type + '_total'] = valueSum;
				return timeExcelData[e];
			}
			//this.formatTime(avgMo));
			else if (/bot/.test(it.agent) || it.agent === this.state.pid) {
				//console.log('bot');
			} else {
				let value = formatMinutesToTime(avgMo, productSettings);
				let valueSum = formatMinutesToTime(sumMo, productSettings);
				othersdata[it.type] = value; //this.formatTime(avgMo);
				othersdata[it.type + '_total'] = valueSum;
			}

			/* if (e >= 0) return (timeExcelData[e][it.type] = it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2))); */
		});
		_.map(timeExcelData, (it) => {
			_.map(['lastmessage_difference', 'lastmessage_difference_total'], (d) => {
				if (it && !it[d]) {
					it[d] = 0;
				}
			});
		});
		let oagent = _.find(timeExcelData, { developer: 'others' });
		if (oagent) {
			_.assign(oagent, othersdata);
		} else {
			timeExcelData.push(othersdata);
		}
		//console.log('timeExcelData', timeExcelData);
		this.setState({ LastMessageDifferenceExcelData: timeExcelData });
	}
	async getAllLastMessageDifferenceTimeData() {
		let { start_date, end_date, productSettings } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let timeAllExcelData = [{ developer: 'All', name: 'All', lastmessage_difference: 0 }];
		let timeData = await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['lastmessage_difference'],
					pid: this.state.pid,
					user_type: 'agent',
				},
				select: '',
				group: ['type'],
				pairs: { agent: 'select1', topic: 'select2', user_type: 'select4' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		_.map(timeData, (it) => {
			let avgMo = it.avg;
			let sumMo = it.sum;

			timeAllExcelData[0][it.type] = formatMinutesToTime(avgMo, productSettings);
			timeAllExcelData[0][it.type + '_total'] = formatMinutesToTime(sumMo, productSettings);
		});
		this.setState({ allLastMessageDifferenceExcelData: timeAllExcelData });
	}
	formatTime(value) {
		const totalSeconds = Math.floor(value / 1000); // Milisaniyeyi saniyeye çevirme
		const hours = Math.floor(totalSeconds / 3600); // Saat hesaplama
		const remainingSeconds = totalSeconds % 3600; // Saat hesabından kalan saniyeler
		const minutes = Math.floor(remainingSeconds / 60); // Dakika hesaplama
		const seconds = remainingSeconds % 60; // Dakika hesabından kalan saniyeler

		return `${hours}:${minutes.toString().padStart(2, '0')}:${seconds.toString().padStart(2, '0')}`;
		return (
			value._data.days * 24 +
			value._data.hours +
			':' +
			moment(value._data.minutes, 'm').format('mm') +
			':' +
			moment(value._data.seconds, 's').format('ss')
		);
	}
	async getClosedFrequency() {
		let { start_date, end_date, pid } = this.state;
		fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: { type: ['closed'], pid },
				select: [],
				group: ['type', 'id', 'topic', 'cid', 'agent'],
				pairs: { agent: 'select1', cid: 'select4', select1: 'select1', topic: 'select2', rate: 'select5', platform: 'platform', id: 'id' },
				options: {
					sum: 0,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let filtered_data = _.orderBy(
					_.filter(data.result, (it) => it.count > 1),
					(o) => o.count,
					'desc'
				);
				let unique_total_closed = [];
				let agent_closed = _.filter(data.result, (it) => it.topic !== 'auto_close');
				let total_closed = _.sumBy(data.result, (it) => it.count);
				let repetitive_conversation = [];
				let unique_agent_closed = [];
				let one_close_agent_closed = [];
				_.map(
					_.groupBy(data.result, (it) => it.cid),
					(o) => {
						unique_total_closed.push(o);
					}
				);
				_.map(
					_.groupBy(agent_closed, (it) => it.cid),
					(o) => {
						if (o.length > 1) repetitive_conversation.push(o);
						unique_agent_closed.push(o);
						if (o.length === 1) one_close_agent_closed.push(o);
					}
				);
				this.setState({
					agent_closed,
					filtered_data,
					unique_total_closed,
					total_closed,
					repetitive_conversation,
					unique_agent_closed,
				});
			});
	}
	async getAllTimeData() {
		let { start_date, end_date, productSettings } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let timeAllExcelData = [
			{ developer: 'All', name: 'All', agentChatTime: 0, chatTimeAfterActivate: 0, agentFirstResponseTimeAfterActivate: 0, agentFirstResponseTime: 0 },
		];
		let timeAllExcelDataG = [
			{ developer: 'All', name: 'All', agentChatTime: 0, chatTimeAfterActivate: 0, agentFirstResponseTimeAfterActivate: 0, agentFirstResponseTime: 0 },
		];
		let timeAllExcelDataAll = [
			{ developer: 'All', name: 'All', agentChatTime: 0, chatTimeAfterActivate: 0, agentFirstResponseTimeAfterActivate: 0, agentFirstResponseTime: 0 },
		];
		let timeData = await fetch('https://log.yapaytech.com/live/test/getInfo?getAllTimeData', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['agentChatTime', 'chatTimeAfterActivate', 'agentFirstResponseTimeAfterActivate', 'agentFirstResponseTime'],
					pid: this.state.pid,
				},
				select: '',
				group: ['type'],
				pairs: { agent: 'select1', topic: 'select2' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		_.map(timeData, (it) => {
			let avgMo = it.avg;
			let sumMo = it.sum;

			timeAllExcelData[0][it.type] = productSettings.showformat ? avgMo && this.formatTime(avgMo) : it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2));
			timeAllExcelDataG[0][it.type] = productSettings.showformat
				? avgMo && this.formatTime(avgMo)
				: it.avg && parseFloat((it.avg / 1000 / 60).toFixed(2));
			timeAllExcelDataAll[0][it.type] = productSettings.showformat
				? sumMo && this.formatTime(sumMo)
				: it.sum && parseFloat((it.sum / 1000 / 60).toFixed(2));
		});
		this.setState({ timeAllExcelData, timeAllExcelDataAll, timeAllExcelDataG });
	}
	async getSendingProduct() {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let sendingData = await fetch('https://live.dahi.ai/analytics/sharedProductCount', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.data;
			});
		let agentData = sendingData.byAgent;
		/* let dayData = _.map(sendingData.byDate, function (it) {
			return _.merge(it, { dayNumber: moment(it.date).dayOfYear() });
		}); */
		_.map(agentData, function (it, i) {
			return (agentData[i].rate = (it.c_total && parseFloat((it.total / it.c_total).toFixed(2))) || 0);
		});
		this.setState({ sendingData: agentData });
	}
	async getSellingData(productAgentList) {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let sellingExcelData = productAgentList;
		let sellingData = await fetch('https://log.yapaytech.com/live/test/getInfo?sss', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				include_hour: true,
				filter: {
					type: ['orderCreated', 'orderCanceled', 'orderRefunded', 'orderSuccessed'],
					pid: this.state.pid,
				},
				group: ['type', 'day', 'cid', 'agent'],
				pairs: { agent: 'select5', kod: 'select2', count: 'count', platform: 'platform', cid: 'select4' },
				options: {
					sum: 1,
					avg: 1,
				},
				agg: {
					rows: 'jsonb_agg(lr.*)',
				},
				from: `(select  COALESCE(lr.total, lr2.total) as total, lr.type, lr.pid, lr.select1, lr.select2, lr.select3, lr.select4, lr.select5, lr.select6, lr.select7, lr.count, lr.date, lr.day, lr.hour, lr.platform from (select *  from live_refined lr where type in ('orderCreated', 'orderCanceled', 'orderRefunded', 'orderSuccessed') and ((day >= '${moment(
					start_date
				).format('YYYY-MM-DD')}' and hour >= ${moment(start_date).format('H')}) and (day <= '${moment(end_date).format(
					'YYYY-MM-DD'
				)}' and (day < '${moment(end_date).format('YYYY-MM-DD')}' or (day = '${moment(end_date).format('YYYY-MM-DD')}' and hour <=  ${moment(
					end_date
				).format('H')}) )  )) and pid = '${
					this.state.pid
				}') lr left join live_refined lr2 on lr2.type='orderCreated' and lr.type <> 'orderCreated' and lr2.select4=lr.select4) as lr`,
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});
		let othersdata = {
			avg: 0,
			basketrate: 0,
			count: 0,
			id: 'others',
			key: 'others',
			len: 0,
			sum: 0,
			text: 'others',
			value: 'others',
		};

		let t_data = [];
		_.map(sellingData, (it) => {
			_.map(
				_.orderBy(it.rows, (r) => r.select7),
				(o) => {
					if (o.select7 && o.select2 && !_.find(t_data, { select2: o.select2 })) t_data.push({ ...o, cid: it.cid, agent: it.agent, id: o.select7 });
					else if (!o.select7 && o.select2 && !(_.find(t_data, { select2: o.select2 }) || _.find(t_data, { select7: o.select2 }))) {
						t_data.push({ ...o, cid: it.cid, agent: it.agent, id: o.select7 });
					}
				}
			);
		});
		let ecommerce_type =
			_.filter(t_data, function (it) {
				return it.id;
			}).length > 0;
		if (ecommerce_type) t_data = _.filter(t_data, (it) => it.id);
		let gt_data = _.groupBy(t_data, 'agent');
		let l_data = [];
		_.map(gt_data, (it) => {
			let tp_group = _.groupBy(it, 'type');
			_.map(tp_group, (o) => {
				let sumcount = _.sumBy(o, 'count');
				let sumtotal = (_.sumBy(o, 'total') && parseFloat(_.sumBy(o, 'total').toFixed(2))) || 0;
				let obj = {
					agent: o[0].agent,
					avg: sumcount ? sumtotal / sumcount : 0,
					count: sumcount,
					len: o.length,
					sum: sumtotal,
					type: o[0].type,
				};
				return l_data.push(obj);
			});
		});

		let l_data_agent = _.groupBy(l_data, 'agent');
		_.map(l_data_agent, function (it) {
			var e = _.findIndex(sellingExcelData, { id: it[0].agent });
			if (e >= 0) {
				return _.assign(sellingExcelData[e], {
					sellingCount: _.sumBy(it, (o) => parseInt(o.len)) || 0,
					productCount: _.sumBy(it, 'count') || 0,
					sellingSum: _.sumBy(it, 'sum') || 0,
					sellingAvg: (_.sumBy(it, 'count') && _.sumBy(it, 'sum') / _.sumBy(it, 'count')) || 0,
				});
			} else {
				if (!/bot/.test(it.agent)) {
					othersdata = _.assign({
						count: othersdata.count + it.count,
						len: othersdata.len + parseFloat(it.len),
						sum: othersdata.sum + it.sum,
					});
				}
			}
		});
		othersdata = {
			productCount: othersdata.count,
			sellingCount: othersdata.len,
			sellingSum: othersdata.sum,
			sellingAvg: othersdata.len ? parseFloat((othersdata.sum / othersdata.len).toFixed(2)) : 0,
			developer: 'Eski Agentlar',
		};
		let sellingBotData = _.map(
			_.filter(sellingData, function (it) {
				return /bot/.test(it.agent);
			}),
			function (o) {
				return { developer: 'Bot', sellingCount: parseFloat(o.len) || 0, productCount: o.count, sellingSum: o.sum, sellingAvg: o.avg };
			}
		);
		_.map(sellingExcelData, (it) => {
			_.map(['sellingCount', 'productCount', 'sellingSum', 'sellingAvg'], (d) => {
				if (it && !it[d]) {
					it[d] = 0;
				}
			});
		});
		this.setState({ sellingExcelData, othersdata, sellingBotData });
	}
	objectIdToDate = (objectId) => {
		const timestamp = parseInt(objectId.substring(0, 8), 16) * 1000;
		return new Date(timestamp).toLocaleString(); // veya istediğiniz tarih formatını kullanabilirsiniz
	};
	async getBotConversation() {
		let { start_date, end_date } = this.state;
		await fetch('https://live.dahi.ai/message/getBotConversations', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date,
				end_date,
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let conversations = _.orderBy(data.conversations, '_id', 'desc');
				let botconversations = _.map(conversations, (it) => {
					return {
						cid: it.cid,
						date: this.objectIdToDate(it._id),
					};
				});
				this.setState({ botconversations });
			});
	}
	async getForgettenBaskets() {
		let { start_date, end_date } = this.state;
		start_date = new Date(start_date);
		end_date = new Date(end_date);
		await fetch('https://micro.yapaytech.com/api/dialogtab/forgottenBaskets', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				pid: this.state.pid,
				start_date,
				end_date,
				page: 0,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let forgottenBaskets = data.result;
				let forgottenBasketsExcel = _.map(forgottenBaskets, (it) => ({
					product_count: it.urun[0].quantity,
					price: it.urun[0].fullprice,
					date: moment(it.updateDate).format('DD-MM-YYYY'),
					user: /[0-9]{12}-/.test(it.uid) ? it.uid.replace(/-.*/, '') : '',
				}));
				this.setState({ forgottenBasketsExcel, forgottenBaskets });
			});
	}
	async getOrderData() {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let orderData = await fetch('https://log.yapaytech.com/live/test/getInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				filter: {
					type: ['orderCreated', 'orderCanceled', 'orderRefunded', 'orderSuccessed'],
					pid: this.state.pid,
				},
				select: '',
				group: ['type', 'day', 'cid', 'agent'],
				pairs: { agent: 'select5', kod: 'select2', count: 'count', platform: 'platform', cid: 'select4' },
				options: {
					sum: 1,
					avg: 1,
				},
				agg: {
					rows: 'jsonb_agg(lr.*)',
				},
				from: `(select  COALESCE(lr.total, lr2.total) as total, lr.type, lr.pid, lr.select1, lr.select2, lr.select3, lr.select4, lr.select5, lr.select6, lr.select7, lr.count, lr.date, lr.day, lr.hour, lr.platform from (select *  from live_refined lr where type in ('orderCreated', 'orderCanceled', 'orderRefunded', 'orderSuccessed') and ((day >= '${moment(
					start_date
				).format('YYYY-MM-DD')}' and hour >= ${moment(start_date).format('H')}) and (day <= '${moment(end_date).format(
					'YYYY-MM-DD'
				)}' and (day < '${moment(end_date).format('YYYY-MM-DD')}' or (day = '${moment(end_date).format('YYYY-MM-DD')}' and hour <=  ${moment(
					end_date
				).format('H')}) )  )) and pid = '${
					this.state.pid
				}') lr left join live_refined lr2 on lr2.type='orderCreated' and lr.type <> 'orderCreated' and lr2.select4=lr.select4) as lr`,
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				return response.result;
			});

		let t_data = [];
		_.map(orderData, (it) => {
			_.map(
				_.orderBy(it.rows, (r) => r.select7),
				(o) => {
					if (o.select7 && o.select2 && !_.find(t_data, { select2: o.select2 }))
						t_data.push({ ...o, cid: it.cid, agent: it.agent, kod: o.select2, id: o.select7, sum: o.total });
					else if (!o.select7 && o.select2 && !(_.find(t_data, { select2: o.select2 }) || _.find(t_data, { select7: o.select2 }))) {
						t_data.push({ ...o, cid: it.cid, agent: it.agent, kod: o.select2, id: o.select7, sum: o.total });
					}
				}
			);
		});

		this.setState({
			orderExcelData: _.filter(t_data, function (it) {
				return it.kod || it.id;
			}),
			orderCanceledExcelData: _.filter(t_data, function (it) {
				return it.type === 'orderCanceled' && (it.kod || it.id);
			}),
			orderRefundedExcelData: _.filter(t_data, function (it) {
				return it.type === 'orderRefunded' && (it.kod || it.id);
			}),
			orderOtherData: _.filter(t_data, function (it) {
				return it.type !== 'orderCreated';
			}),
		});
	}
	async getOrderCollectaction() {
		let { start_date, end_date } = this.state;
		/* start_date = moment(start_date).format();
		end_date = moment(end_date).format(); */
		await fetch('https://log.collectaction.com/api/getUserOrders', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: 'b59ce1f4-d16c-464c-90ee-5c297d8ab9fb',
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = _.filter(data.data, (it) => it.extra.agent_id && /livechat/.test(it.extra.agent_id));
				result = _.uniqBy(result, 'code');
				this.setState({ orderCollectactionData: _.sortBy(result, ['created_at', 'asc']) });
			});
	}
	async getSellingCollectaction(productAgentList) {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		let sellingExcelData = productAgentList;
		let sellingData = await fetch('https://log.collectaction.com/api/getUserOrders', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: 'b59ce1f4-d16c-464c-90ee-5c297d8ab9fb',
			}),
		})
			.then((response) => response.json())
			.then((response) => {
				let result = _.filter(response.data, (it) => it.extra.agent_id && /livechat/.test(it.extra.agent_id));
				result = _.uniqBy(result, 'code');
				return result;
			});
		let agentList = _.map(sellingData, function (it) {
			let regex = new RegExp(it.extra.agent_id.replace('livechat_', ''));
			let agent = _.find(productAgentList, (o) => regex.test(o.name));
			return {
				key: (agent && agent.id) || it.extra.agent_id,
				text: it.extra.agent_id.replace('livechat_', ''),
				value: it.extra.agent_id,
				id: it.extra.agent_id,
				lenCanceled: 0,
				countCanceled: 0,
				sumCanceled: 0,
				avgCanceled: 0,
				lenRefunded: 0,
				countRefunded: 0,
				sumRefunded: 0,
				avgRefunded: 0,
			};
		});
		agentList = _.uniqBy(agentList, 'key');
		let othersdata = {
			avg: 0,
			basketrate: 0,
			count: 0,
			id: 'others',
			key: 'others',
			len: 0,
			sum: 0,
			text: 'others',
			value: 'others',
		};

		let t_data = [];
		_.map(sellingData, (it) => {
			let regex = new RegExp(it.extra.agent_id.replace('livechat_', ''));
			let agent = _.find(productAgentList, (o) => regex.test(o.name));
			if (agent) {
				let obj = {
					day: moment(it.created_at).format('YYYY-MM-DD'), //'2023-07-30',
					pid: it.pid,
					date: it.created_at,
					hour: moment(it.created_at).hour(),
					type: 'orderCreated',
					count: it.products.length,
					total: it.total,
					select1: agent && agent.id,
					select2: it.code,
					select3: '',
					select4: '',
					select5: agent && agent.id,
					select6: it.created_at,
					select7: null,
					platform: 'web',
					cid: '',
					agent: agent.id,
					id: null,
				};
				t_data.push(obj);
			}
		});
		let ecommerce_type =
			_.filter(t_data, function (it) {
				return it.id;
			}).length > 0;
		if (ecommerce_type) t_data = _.filter(t_data, (it) => it.id);
		let gt_data = _.groupBy(t_data, 'agent');
		let l_data = [];
		_.map(gt_data, (it) => {
			let tp_group = _.groupBy(it, 'type');
			_.map(tp_group, (o) => {
				let sumcount = _.sumBy(o, 'count');
				let sumtotal = (_.sumBy(o, 'total') && parseFloat(_.sumBy(o, 'total').toFixed(2))) || 0;
				let obj = {
					agent: o[0].agent,
					avg: sumcount ? sumtotal / sumcount : 0,
					count: sumcount,
					len: o.length,
					sum: sumtotal,
					type: o[0].type,
				};
				return l_data.push(obj);
			});
		});

		let l_data_agent = _.groupBy(l_data, 'agent');
		_.map(l_data_agent, function (it) {
			var e = _.findIndex(sellingExcelData, { id: it[0].agent });
			if (e >= 0) {
				return _.assign(sellingExcelData[e], {
					sellingCount: _.sumBy(it, (o) => parseInt(o.len)) || 0,
					productCount: _.sumBy(it, 'count') || 0,
					sellingSum: _.sumBy(it, 'sum') || 0,
					sellingAvg: (_.sumBy(it, 'count') && _.sumBy(it, 'sum') / _.sumBy(it, 'count')) || 0,
				});
			} else {
				if (!/bot/.test(it.agent)) {
					othersdata = _.assign({
						count: othersdata.count + it.count,
						len: othersdata.len + parseFloat(it.len),
						sum: othersdata.sum + it.sum,
					});
				}
			}
		});
		othersdata = {
			productCount: othersdata.count,
			sellingCount: othersdata.len,
			sellingSum: othersdata.sum,
			sellingAvg: othersdata.len ? parseFloat((othersdata.sum / othersdata.len).toFixed(2)) : 0,
			developer: 'Eski Agentlar',
		};
		let sellingBotData = _.map(
			_.filter(sellingData, function (it) {
				return /bot/.test(it.agent);
			}),
			function (o) {
				return { developer: 'Bot', sellingCount: parseFloat(o.len) || 0, productCount: o.count, sellingSum: o.sum, sellingAvg: o.avg };
			}
		);
		_.map(sellingExcelData, (it) => {
			_.map(['sellingCount', 'productCount', 'sellingSum', 'sellingAvg'], (d) => {
				if (it && !it[d]) {
					it[d] = 0;
				}
			});
		});
		this.setState({ sellingExcelData, othersdata, sellingBotData });
	}
	async getTemplateData() {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		await fetch('https://log.yapaytech.com/live/getEventInfo', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					label: 'template',
					pid: this.state.pid,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ templateTotalData: data.result.total, loading: false });
			});
	}
	async getConversationData() {
		let { start_date, end_date } = this.state;
		start_date = moment(start_date).format();
		end_date = moment(end_date).format();
		await fetch('https://live.dahi.ai/analytics/conversationByGroup', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({ conversationGroupData: data.data, loading: false });
			});
	}

	async getStockInfo() {
		let { start_date, end_date } = this.state;
		await fetch('https://log.yapaytech.com/live/getEvents', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date,
				end_date,
				filter: {
					label: 'out-of-stock',
					pid: this.state.pid,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newdata = [];
				_.map(_.orderBy(data.result, 'created_at', 'desc'), (it) =>
					newdata.push({
						product_code: it.extra.product_code,
						product_name: it.extra.product_name,
						size: it.extra.product_size,
						phone: it.extra.user_phone,
						date: moment(it.created_at).format('DD-MM-YYYY HH:mm'),
					})
				);
				this.setState({ stockresult: newdata });
			});
	}
	async getGeneralGraph() {
		let { start_date, end_date, pid } = this.state;
		fetch('https://log.yapaytech.com/live/getWaitingInfo1?totalWaitingConv', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					/* 	totalWaitingConv: data && data.result && data.result.result && data.result.result[0] && data.result.result[0].count, */
					loadingwaitingTotalData: false,
					loading: false,
				});
			});
		await fetch('https://log.yapaytech.com/live/getEventInfoGeneral?filtertest', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					label: 'activateAgent',
					pid: pid,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					loadingTotalWaitingConv: false,
					//totalWaitingConv: data.result.total,
					totalWaitingcConv: data.result.c_total,
					totalWaitingConvHourly: data.result.result,
				});
			});
		let start_date_1 = moment(start_date).format();
		let end_date_1 = moment(end_date).format();
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayHho', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['closed', 'contacted'], pid },
				select: [],
				group: ['type', 'agent', 'day', 'hour'],
				pairs: { agent: 'select1' },
				options: {},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				//console.log('data', data);
				_.each(data.result, function (it) {
					return (it.dayNumber = moment(it.day).dayOfYear());
				});
				let filter = _.filter(data.result, function (it) {
					return it.agent !== '5e6f519560b2b4d07559fcf8';
				});
				let onlyAgentCounts = _.groupBy(
					_.filter(data.result, function (it) {
						return it.agent !== pid && it.type === 'closed';
					}),
					'dayNumber'
				);
				this.setState({
					loadingtotalClosedDataHourly: false,
					totalClosedDataHourly: _.sumBy(filter, 'count') || 0,
					totalAgentClosedDataHourly: onlyAgentCounts,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayHho', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['contacted'], pid },
				select: [],
				group: ['type', 'agent', 'day', 'hour'],
				pairs: { agent: 'select1' },
				options: {
					cids: 'count(distinct select2)',
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				_.each(data.result, function (it) {
					return (it.dayNumber = moment(it.day).dayOfYear());
				});
				_.each(data.result, function (it) {
					return (it.count = parseInt(it.cids));
				});
				let contactedDataHourly = _.groupBy(
					_.filter(data.result, function (it) {
						return it.type === 'contacted';
					}),
					'dayNumber'
				);
				this.setState({
					contactedDataHourly,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayagentFirstResponseTimeAfterActivate', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['agentFirstResponseTimeAfterActivate'], pid },
				select: [],
				group: ['id', 'type', 'day', 'hour'],
				pairs: { agent: 'select1' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				_.each(data.result, function (it) {
					return (it.dayNumber = moment(it.day).dayOfYear());
				});
				let agentFirstResponseTimeAfterActivateDataHourly = _.groupBy(
					_.filter(data.result, function (it) {
						return it.agent !== pid && it.type === 'agentFirstResponseTimeAfterActivate';
					}),
					'dayNumber'
				);
				this.setState({
					agentFirstResponseTimeAfterActivateDataHourly,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayagentFirstResponseTimeAfterActivate', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['agentFirstResponseTimeAfterActivate'], pid },
				select: [],
				group: ['id', 'type', 'day', 'hour'],
				pairs: { agent: 'select1', id: 'id' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			// Veri yüklendikten sonra
			.then((data) => {
				// Önce dayNumber ekleyin
				_.each(data.result, function (it) {
					return (it.dayNumber = moment(it.day).dayOfYear());
				});

				// Verileri filtreleyin (sl_20)
				let sl_20 = _.filter(data.result, function (it) {
					return it.agent !== pid && it.sum <= 20000;
				});

				// Verileri filtreleyin (sl_30)
				let sl_30 = _.filter(data.result, function (it) {
					return it.agent !== pid && it.sum <= 30000;
				});

				// Günlere göre gruplanmış veriler
				let sl_20_grouped = {};
				let sl_30_grouped = {};

				// Günlere göre grupla
				let dayGroups = _.groupBy(sl_20, 'dayNumber');
				let dayGroups_30 = _.groupBy(sl_30, 'dayNumber');

				// Her gün için saatlere göre grupla ve özet bilgileri hesapla
				Object.keys(dayGroups).forEach((day) => {
					sl_20_grouped[day] = [];

					// Saatlere göre grupla
					let hourGroups = _.groupBy(dayGroups[day], 'hour');

					// Her saat için toplamları hesapla
					Object.keys(hourGroups).forEach((hour) => {
						let entries = hourGroups[hour];
						let count = entries.length;
						let sum = _.sumBy(entries, 'sum');
						let avg = sum / count;

						// Örnek bir giriş alalım
						let sampleEntry = entries[0];

						// Gruplandırılmış veriyi ekle
						sl_20_grouped[day].push({
							count: count,
							len: String(count),
							sum: sum,
							avg: avg,
							type: sampleEntry.type,
							day: sampleEntry.day,
							hour: parseInt(hour),
							dayNumber: parseInt(day),
						});
					});

					// Saate göre sırala
					sl_20_grouped[day] = _.sortBy(sl_20_grouped[day], 'hour');
				});

				Object.keys(dayGroups_30).forEach((day) => {
					sl_30_grouped[day] = [];

					// Saatlere göre grupla
					let hourGroups = _.groupBy(dayGroups_30[day], 'hour');

					// Her saat için toplamları hesapla
					Object.keys(hourGroups).forEach((hour) => {
						let entries = hourGroups[hour];
						let count = entries.length;
						let sum = _.sumBy(entries, 'sum');
						let avg = sum / count;

						// Örnek bir giriş alalım
						let sampleEntry = entries[0];

						// Gruplandırılmış veriyi ekle
						sl_30_grouped[day].push({
							count: count,
							len: String(count),
							sum: sum,
							avg: avg,
							type: sampleEntry.type,
							day: sampleEntry.day,
							hour: parseInt(hour),
							dayNumber: parseInt(day),
						});
					});

					// Saate göre sırala
					sl_30_grouped[day] = _.sortBy(sl_30_grouped[day], 'hour');
				});

				// SADECE SAATE GÖRE GRUPLAMA - GÜN BAĞIMSIZ
				// sl_20 için saatlik gruplama
				let sl_20_hourly = {};
				let hourlyGroups_20 = _.groupBy(sl_20, 'hour');

				// Her saat için toplamları hesapla
				Object.keys(hourlyGroups_20).forEach((hour) => {
					let entries = hourlyGroups_20[hour];
					let count = entries.length;
					let sum = _.sumBy(entries, 'sum');
					let avg = sum / count;

					// Gruplandırılmış veriyi ekle
					sl_20_hourly[hour] = {
						count: count,
						len: String(count),
						sum: sum,
						avg: avg,
						type: 'agentFirstResponseTimeAfterActivate',
						hour: parseInt(hour),
					};
				});

				// sl_30 için saatlik gruplama
				let sl_30_hourly = {};
				let hourlyGroups_30 = _.groupBy(sl_30, 'hour');

				// Her saat için toplamları hesapla
				Object.keys(hourlyGroups_30).forEach((hour) => {
					let entries = hourlyGroups_30[hour];
					let count = entries.length;
					let sum = _.sumBy(entries, 'sum');
					let avg = sum / count;

					// Gruplandırılmış veriyi ekle
					sl_30_hourly[hour] = {
						count: count,
						len: String(count),
						sum: sum,
						avg: avg,
						type: 'agentFirstResponseTimeAfterActivate',
						hour: parseInt(hour),
					};
				});

				this.setState({ sl_20_grouped, sl_30_grouped, sl_20_hourly, sl_30_hourly });
			});
		await fetch('https://log.yapaytech.com/live/getEventInfoGeneralByHour', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					label: 'activateAgent',
					pid: pid,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.setState({
					totalWaitingConvDayHourly: data.result.result,
				});
			});
		fetch('https://log.yapaytech.com/live/getEventInfoGeneralByHour', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				filter: {
					pid: this.state.pid,
				},
				labels: ['opened'],
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let opened_list = _.filter(data.result.result, { label: 'opened' });
				this.setState({
					totalOpenedConvDayHourly: opened_list,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayHho', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['contacted'], pid },
				select: [],
				group: ['type', 'agent', 'hour'],
				pairs: { agent: 'select1' },
				options: {
					cids: 'count(distinct select2)',
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				_.each(data.result, function (it) {
					return (it.count = parseInt(it.cids));
				});
				let contactedDataDayHourly = _.groupBy(
					_.filter(data.result, function (it) {
						return it.type === 'contacted';
					}),
					'hour'
				);
				this.setState({
					contactedDataDayHourly,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayagentFirstResponseTimeAfterActivate', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['agentFirstResponseTimeAfterActivate'], pid },
				select: [],
				group: ['type', 'hour'],
				pairs: { agent: 'select1' },
				options: {
					sum: 1,
					avg: 1,
				},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let agentFirstResponseTimeAfterActivateDataDayHourly = _.groupBy(
					_.filter(data.result, function (it) {
						return it.agent !== pid && it.type === 'agentFirstResponseTimeAfterActivate';
					}),
					'hour'
				);
				this.setState({
					agentFirstResponseTimeAfterActivateDataDayHourly: data.result,
				});
			});
		await fetch('https://log.yapaytech.com/live/test/getInfo?dayHho', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date_1,
				end_date: end_date_1,
				include_hour: true,
				filter: { type: ['closed'], pid },
				select: [],
				group: ['type', 'agent', 'hour'],
				pairs: { agent: 'select1' },
				options: {},
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let filter = _.filter(data.result, function (it) {
					return it.agent !== '5e6f519560b2b4d07559fcf8';
				});
				let onlyAgentCounts = _.groupBy(
					_.filter(data.result, function (it) {
						return it.agent !== pid && it.type === 'closed';
					}),
					'hour'
				);
				this.setState({
					loadingtotalClosedDataDayHourly: false,
					totalClosedDataDayHourly: _.sumBy(filter, 'count') || 0,
					totalAgentClosedDataDayHourly: onlyAgentCounts,
				});
			});
	}
	async getAgentTimeLine(productAgentList) {
		let { start_date, end_date, pid } = this.state;
		let _start = moment(start_date);
		let _end = moment() > moment(end_date) ? moment(end_date) : moment();
		await fetch('https://log.yapaytech.com/live/timeline/agent ', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: start_date,
				end_date: end_date,
				pid: this.state.pid,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let newData = _.map(data, (it) => ({
					agent: it.agent,
					last_status: it.last_status,
					changes: it.changes
						? _.filter(
								_.map(it.changes, function (a, i) {
									if (i === 0) {
										return a;
									} else {
										if (it.changes[i - 1].status !== it.changes[i].status) {
											return a;
										}
									}
								}),
								function (o) {
									return o && o.date;
								}
						  )
						: [],
				}));
				let agent_total_status = [];
				_.each(newData, function (it, s) {
					if (it.changes && it.changes.length) {
						_.each(it.changes, (a, i) => {
							let start = moment(a.date);
							let end = it.changes[i + 1] && it.changes[i + 1].date ? moment(it.changes[i + 1].date) : _end;
							if (i === 0 && start > _start) {
								if (start.diff(_start))
									agent_total_status.push({
										agent: it.agent,
										status: it.last_status,
										time: start.diff(_start, 'ms'),
									});
							}
							if (end.diff(start))
								agent_total_status.push({
									agent: it.agent,
									status: a.status,
									time: end.diff(start, 'ms'),
								});
						});
					} else {
						if (_end.diff(_start))
							agent_total_status.push({
								agent: it.agent,
								status: it.last_status,
								time: _end.diff(_start, 'ms'),
							});
					}
				});
				agent_total_status = _.groupBy(agent_total_status, 'agent');
				let agent_timeline_exceldata = [];
				/* console.log('it.id', it.id); */
				_.each(productAgentList, (it) => {
					let status_array = agent_total_status[it.id];
					let online_time = (_.sumBy(_.filter(status_array, { status: 'online' }), 'time') / 1000 / 60).toFixed(2);
					let offline_time = (_.sumBy(_.filter(status_array, { status: 'offline' }), 'time') / 1000 / 60).toFixed(2);
					let idle_time = (_.sumBy(_.filter(status_array, { status: 'idle_agent' }), 'time') / 1000 / 60).toFixed(2);
					let null_time = (_.sumBy(_.filter(status_array, { status: null }), 'time') / 1000 / 60).toFixed(2);
					return agent_timeline_exceldata.push({ email: it.developer, online_time, offline_time, idle_time, null_time });
				});
				this.setState({ agent_timeline_exceldata: agent_timeline_exceldata });
			});
	}
	getNewData = () => {
		let { startDate, endDate, newDataToggle } = this.state;
		this.setState({
			newDataToggle: !newDataToggle,
			startDate1: startDate,
			endDate1: endDate,
			openPopup: false,
		});
	};
	async getIntentData() {
		let { start_date, end_date } = this.state;
		await fetch('https://log.yapaytech.com/live/getWaitingInfoIntentForward', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				start_date: moment(start_date).valueOf(),
				end_date: moment(end_date).valueOf(),
				pid: this.state.pid,
				select: '*',
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let result = data && data.result && data.result.result;
				let web_conversations = _.filter(result, { platform: 'web' });
				let whatsapp_conversations = _.filter(result, { platform: 'whatsapp' });
				let group_by_intent = _.groupBy(web_conversations, (it) => it.extra && it.extra.starting_forward_intent);
				let group_by_intent_whatsapp = _.groupBy(whatsapp_conversations, (it) => it.extra && it.extra.starting_forward_intent);
				this.setState({
					group_by_intent,
					group_by_intent_whatsapp,
					web_conversations,
					whatsapp_conversations,
				});
			});
	}
	async getIntents() {
		await fetch('/api/dahi/message/getIntents')
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let intents = data && data.result;
				let whatsapp_intents = data && data.whatsapp_intents;
				this.setState({ intents, whatsapp_intents });
			});
	}
	exportExcel = (t, onePage, path) => {
		let value = this.state.productAgentList;
		//console.log('cc', value);
		let product = this.props.product.live;
		let pid = this.state.pid;
		let {
			start_date,
			end_date,
			contactedDataHourly,
			totalAgentClosedDataHourly,
			totalWaitingConvHourly,
			totalOpenedConvHourly,
			totalWaitingConvDayHourly,
			totalOpenedConvDayHourly,
			contactedDataDayHourly,
			totalAgentClosedDataDayHourly,
			rateList,
			excelgroupedRateList,
			allClosedData,
			missing_list,
			intents,
			whatsapp_intents,
			group_by_intent,
			group_by_intent_whatsapp,
			web_conversations,
			whatsapp_conversations,
		} = this.state;
		let ecommerce,
			sendProduct,
			conversationGroup,
			showTemplate,
			ratePoint,
			rateComment,
			generalTable,
			stockinfo,
			allConversationTable,
			orderCollectaction,
			forwardIntent,
			botConversations;
		//timeline = true;
		if (product.settings.analyticView) {
			ecommerce = product.settings.analyticView.ecommerce;
			sendProduct = product.settings.analyticView.sendProduct;
			conversationGroup = product.settings.analyticView.conversationGroup;
			showTemplate = product.settings.analyticView.showTemplate;
			//timeline = product.settings.analyticView.timeline;
			//userlist = product.settings.analyticView.userlist;
			ratePoint = product.settings.analyticView.ratePoint;
			rateComment = product.settings.analyticView.rateComment;
			generalTable = product.settings.analyticView.generalTable;
			stockinfo = product.settings.analyticView.stockinfo;
			allConversationTable = product.settings.analyticView.allConversationTable;
			orderCollectaction = product.settings.analyticView.orderCollectaction;
			forwardIntent = product.settings.analyticView.forwardIntent;
			botConversations = product.settings.analyticView.botConversations;
		}
		let closedTopic = this.state.closedTopicData;
		let closedXAgent = ratePoint
			? [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('closed'), key: 'closed' },
					{ title: t('rateCount'), key: 'ratedCount' },
					{ title: t('averageRate'), key: 'avgRate' },
					{ title: '1', key: 'rates_one' },
					{ title: '2', key: 'rates_two' },
					{ title: '3', key: 'rates_three' },
					{ title: '4', key: 'rates_four' },
					{ title: '5', key: 'rates_five' },
			  ]
			: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('closed'), key: 'closed' },
			  ];
		let closedXTopic = ratePoint
			? [
					{ title: t('topic'), key: 'topic' },
					{ title: t('count'), key: 'count' },
					{ title: t('rateCount'), key: 'ratedCount' },
					{ title: t('averageRate'), key: 'avgRate' },
					{ title: '1', key: 'rates_one' },
					{ title: '2', key: 'rates_two' },
					{ title: '3', key: 'rates_three' },
					{ title: '4', key: 'rates_four' },
					{ title: '5', key: 'rates_five' },
			  ]
			: [
					{ title: t('topic'), key: 'topic' },
					{ title: t('count'), key: 'count' },
			  ];
		let sendingData = this.state.sendingData;
		let sellingBotData = this.state.sellingBotData;
		let timeAllExcelData = this.state.timeAllExcelData;
		let forgottenBasketsExcel = this.state.forgottenBasketsExcel;
		let orderExcelData = this.state.orderExcelData;
		//let sellingData = this.state.sellingData;
		let orderCanceledExcelData = this.state.orderCanceledExcelData;
		let orderRefundedExcelData = this.state.orderRefundedExcelData;
		let orderOtherData = this.state.orderOtherData;
		let othersdata = this.state.othersdata;
		let templateTotalData = this.state.templateTotalData;
		let conversationGroupData = this.state.conversationGroupData;
		let orderCollectactionData = this.state.orderCollectactionData;
		let stockresult = this.state.stockresult;
		let agent_timeline_exceldata = this.state.agent_timeline_exceldata;
		let botconversations = this.state.botconversations;
		let LastMessageDifferenceExcelData = this.state.LastMessageDifferenceExcelData;
		let allLastMessageDifferenceExcelData = this.state.allLastMessageDifferenceExcelData;
		//let orderExcelDataFiltered = [];
		let generalTableData = [],
			generalGraphDataHourly = [],
			generaldataDayHourly = [];

		//console.log('orderExcelData', orderExcelData);
		if (ecommerce) {
			_.map(orderExcelData, (it) => {
				it.developer = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).developer) || 'Bot';
				it.name = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).name) || 'Bot';
				it.status = (_.find(orderOtherData, { kod: it.kod }) && t(_.find(orderOtherData, { kod: it.kod }).type)) || t('created');
			});
			_.map(orderCanceledExcelData, (it) => {
				it.developer = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).developer) || 'Bot';
				it.name = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).name) || 'Bot';
				it.status = t(it.type);
			});
			_.map(orderRefundedExcelData, (it) => {
				it.developer = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).developer) || 'Bot';
				it.name = (_.find(value, { id: it.agent }) && _.find(value, { id: it.agent }).name) || 'Bot';
				it.status = t(it.type);
			});
		}
		if (orderCollectactionData) {
			_.map(orderCollectactionData, (it) => {
				it.developer =
					(_.find(value, { fullname: it.extra.agent_id.replace('livechat_', '') }) &&
						_.find(value, { fullname: it.extra.agent_id.replace('livechat_', '') }).developer) ||
					it.extra.agent_id;
				it.date = moment(it.created_at).format('DD-MM-YYYY HH:mm');
				it.address = it.extra.user.address;
				it.district = it.extra.user.district;
				it.email = it.extra.user.email;
				it.gender = it.extra.user.gender;
				it.name = it.extra.user.name + ' ' + it.extra.user.lastname;
				it.number = it.extra.user.number;
				it.town = it.extra.user.town;
				it.user = it.extra.user;
			});
		}
		let filtervalue = _.filter(value, function (o) {
			return o.developer !== 'sephora@yapaytech.com';
		});
		let sellingValue = _.concat(filtervalue, sellingBotData);
		if (othersdata && othersdata.productCount) {
			sellingValue = _.concat(sellingValue, othersdata);
		}
		let sellingConcatValue = _.concat(sellingValue, {
			developer: 'All',
			name: 'All',
			count: _.sumBy(filtervalue, 'count'),
			ratedCount: _.sumBy(filtervalue, 'ratedCount'),
			viewed: _.sumBy(filtervalue, 'viewed'),
			taken: _.sumBy(filtervalue, 'taken'),
			contacted: _.sumBy(filtervalue, 'contacted'),
			forwarded: _.sumBy(filtervalue, 'forwarded'),
			closed: _.sumBy(filtervalue, 'closed'),
			avgRate: _.sumBy(filtervalue, 'ratedCount') ? (_.sumBy(filtervalue, 'total') / _.sumBy(filtervalue, 'ratedCount')).toFixed(2) : 0,
			sellingCount: _.sumBy(sellingValue, 'sellingCount'),
			productCount: _.sumBy(sellingValue, 'productCount'),
			sellingSum: _.sumBy(sellingValue, 'sellingSum'),
			sellingAvg: _.sumBy(sellingValue, 'sellingCount') && _.sumBy(sellingValue, 'sellingSum') / _.sumBy(sellingValue, 'sellingCount'),
			agentChatTime: timeAllExcelData && timeAllExcelData[0].agentChatTime,
			agentFirstResponseTimeAfterActivate: timeAllExcelData && timeAllExcelData[0].agentFirstResponseTimeAfterActivate,
			agentFirstResponseTime: timeAllExcelData && timeAllExcelData[0].agentFirstResponseTime,
			chatTimeAfterActivate: timeAllExcelData && timeAllExcelData[0].chatTimeAfterActivate,
			lastmessage_difference: allLastMessageDifferenceExcelData && allLastMessageDifferenceExcelData[0].lastmessage_difference,
			rates_one: _.sumBy(filtervalue, 'rates_one'),
			rates_two: _.sumBy(filtervalue, 'rates_two'),
			rates_three: _.sumBy(filtervalue, 'rates_three'),
			rates_four: _.sumBy(filtervalue, 'rates_four'),
			rates_five: _.sumBy(filtervalue, 'rates_five'),
		});
		sellingConcatValue = _.filter(sellingConcatValue, function (it) {
			return it && it.developer;
		});
		let concatValue = _.concat(value, {
			developer: 'All',
			name: 'All',
			count: _.sumBy(filtervalue, 'count'),
			ratedCount: _.sumBy(filtervalue, 'ratedCount'),
			viewed: _.sumBy(filtervalue, 'viewed'),
			taken: _.sumBy(filtervalue, 'taken'),
			contacted: _.sumBy(filtervalue, 'contacted'),
			forwarded: _.sumBy(filtervalue, 'forwarded'),
			closed: _.sumBy(filtervalue, 'closed'),
			avgRate: _.sumBy(filtervalue, 'ratedCount') ? (_.sumBy(filtervalue, 'total') / _.sumBy(filtervalue, 'ratedCount')).toFixed(2) : 0,
			sellingCount: _.sumBy(filtervalue, 'sellingCount'),
			productCount: _.sumBy(sellingValue, 'productCount'),
			sellingSum: _.sumBy(filtervalue, 'sellingSum'),
			sellingAvg: _.sumBy(filtervalue, 'sellingCount') && _.sumBy(filtervalue, 'sellingSum') / _.sumBy(filtervalue, 'sellingCount'),
			agentChatTime: timeAllExcelData && timeAllExcelData[0].agentChatTime,
			agentFirstResponseTimeAfterActivate: timeAllExcelData && timeAllExcelData[0].agentFirstResponseTimeAfterActivate,
			agentFirstResponseTime: timeAllExcelData && timeAllExcelData[0].agentFirstResponseTime,
			chatTimeAfterActivate: timeAllExcelData && timeAllExcelData[0].chatTimeAfterActivate,
			lastmessage_difference: allLastMessageDifferenceExcelData && allLastMessageDifferenceExcelData[0].lastmessage_difference,
			rates_one: _.sumBy(filtervalue, 'rates_one'),
			rates_two: _.sumBy(filtervalue, 'rates_two'),
			rates_three: _.sumBy(filtervalue, 'rates_three'),
			rates_four: _.sumBy(filtervalue, 'rates_four'),
			rates_five: _.sumBy(filtervalue, 'rates_five'),
		});
		if (!onePage || (onePage && /closedtag|rateslist/.test(path)))
			closedTopic.push({
				topic: 'All',
				count: _.sumBy(filtervalue, 'closed'),
				ratedCount: _.sumBy(filtervalue, 'ratedCount'),
				avgRate: _.sumBy(filtervalue, 'ratedCount') ? (_.sumBy(filtervalue, 'total') / _.sumBy(filtervalue, 'ratedCount')).toFixed(2) : 0,
				rates_one: _.sumBy(filtervalue, 'rates_one'),
				rates_two: _.sumBy(filtervalue, 'rates_two'),
				rates_three: _.sumBy(filtervalue, 'rates_three'),
				rates_four: _.sumBy(filtervalue, 'rates_four'),
				rates_five: _.sumBy(filtervalue, 'rates_five'),
			});
		if (sendProduct) {
			sendingData = _.filter(sendingData, function (it) {
				return it.email !== 'sephora@yapaytech.com';
			});
			sendingData.push({
				email: 'All',
				total: _.sumBy(sendingData, 'total'),
				c_total: _.sumBy(sendingData, 'c_total'),
				u_total: _.sumBy(sendingData, 'u_total'),
				rate: (_.sumBy(sendingData, 'c_total') && parseFloat((_.sumBy(sendingData, 'total') / _.sumBy(sendingData, 'c_total')).toFixed(2))) || 0,
			});
		}
		if (generalTable && !onePage) {
			generalTableData = [
				{
					type: 'Toplam Bekleyen',
					count: this.state.totalWaitingConv,
				},
				{
					type: 'Toplam Etkileşime Geçilen',
					count: this.state.totalWaitingConv - ((missing_list && missing_list.length) || 0),
				},
				{
					type: 'Toplam Kayıp Konuşma',
					count: missing_list.length,
				},
				{
					type: 'Toplam Kapatma',
					count: this.state.totalAgentClosedData,
				},
				{
					type: 'Bekleme Süresi',
					count: this.state.timeAllExcelDataG[0].agentFirstResponseTimeAfterActivate,
				},
				{
					type: 'Agent ilk Cevap Verme Süresi',
					count: this.state.timeAllExcelDataG[0].agentFirstResponseTime,
				},
				{
					type: 'Toplam Görüşme Süresi',
					count: this.state.timeAllExcelDataAll[0].chatTimeAfterActivate,
				},
				{
					type: 'Ortalama Görüşme Süresi',
					count: this.state.timeAllExcelDataG[0].chatTimeAfterActivate,
				},
			];
			//console.log('-1');
			/* console.log('contactedDataHourly', contactedDataHourly); */
			generalGraphDataHourly = []; /*chartData(
				contactedDataHourly,
				totalAgentClosedDataHourly,
				totalWaitingConvHourly,
				totalOpenedConvHourly,
				start_date,
				end_date,
				t,
				missing_list,
				this.state.getWaitingInfo1Data
			);*/
			generaldataDayHourly = []; /* chartDataDayHourly(
				totalWaitingConvDayHourly,
				contactedDataDayHourly,
				totalAgentClosedDataDayHourly,
				totalOpenedConvDayHourly,
				start_date,
				end_date,
				t,
				missing_list
			); */
		}
		if (sendProduct) {
			_.each(sellingConcatValue, function (it) {
				let d = _.find(sendingData, function (o) {
					return it.developer === o.email;
				});
				if (d) {
					it.send_total = d.total;
					it.send_c_total = d.c_total;
					it.send_u_total = d.u_total;
					it.send_rate = d.rate;
				} else {
					it.send_total = 0;
					it.send_c_total = 0;
					it.send_u_total = 0;
					it.send_rate = 0;
				}
			});
		}

		let filterConcatValue = _.filter(concatValue, function (o) {
			return o.developer !== 'sephora@yapaytech.com';
		});
		let allX = [
			{ title: t('developer'), key: 'developer' },
			{ title: t('name'), key: 'name' },
			{ title: t('viewed'), key: 'viewed' },
			{ title: t('taken'), key: 'taken' },
			{ title: t('contacted'), key: 'contacted' },
			{ title: t('closed'), key: 'closed' },
			{ title: t('forwarded'), key: 'forwarded' },
			{ title: t('firstResponseActivate'), key: 'agentFirstResponseTimeAfterActivate' },
			{ title: t('firstResponse'), key: 'agentFirstResponseTime' },
			{ title: t('agentChatTime'), key: 'agentChatTime' },
			{ title: t('chatTimeActivate'), key: 'chatTimeAfterActivate' },
		];
		let sheets = [];
		//console.log('1');
		if (!onePage || (onePage && /agent/.test(path)))
			sheets.push({
				name: 'agent',
				x: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('viewed'), key: 'viewed' },
					{ title: t('taken'), key: 'taken' },
					{ title: t('contacted'), key: 'contacted' },
					{ title: t('closed'), key: 'closed' },
					{ title: t('forwarded'), key: 'forwarded' },
				],
				datasets: _.filter(concatValue, function (o) {
					return o.developer !== 'sephora@yapaytech.com';
				}),
			});
		if (!onePage || (onePage && /closedtag/.test(path))) {
			sheets.push({
				name: 'closed_agent',
				x: closedXAgent,
				datasets: _.filter(concatValue, function (o) {
					return o.developer !== 'sephora@yapaytech.com';
				}),
			});
			sheets.push({
				name: 'closed_topic',
				x: closedXTopic,
				datasets: closedTopic,
			});
		}
		//console.log('2');
		if (!onePage || (onePage && /closedgeneral/.test(path))) {
			let { unique_total_closed, total_closed, repetitive_conversation, agent_closed, unique_agent_closed } = this.state;
			let closed_general_data = [
				{ name: 'Toplam Kapatma Sayısı (auto_close dahil)', count: total_closed },
				{ name: 'Tekil Toplam Kapatma Sayısı (auto_close dahil)', count: unique_total_closed.length },
				{ name: 'Agent Toplam Kapatma Sayısı (auto_close hariç)', count: agent_closed.length },
				{ name: 'Agent Tekil Toplam Kapatma Sayısı (auto_close hariç)', count: unique_agent_closed.length },
				{ name: 'Mükerrer Kapatılan Konuşma Sayısı', count: repetitive_conversation.length },
				{ name: '5 ve Daha Fazla Kapatılmış', count: _.filter(repetitive_conversation, (it) => it.length >= 5).length || 0 },
				{ name: '4 Kere Kapatılmış', count: _.filter(repetitive_conversation, (it) => it.length === 4).length || 0 },
				{ name: '3 Kere Kapatılmış', count: _.filter(repetitive_conversation, (it) => it.length === 3).length || 0 },
				{ name: '2 Kere Kapatılmış', count: _.filter(repetitive_conversation, (it) => it.length === 2).length || 0 },
			];
			sheets.push({
				name: 'closed_general',
				x: [
					{ title: t('conversation'), key: 'name' },
					{ title: t('count'), key: 'count' },
				],
				datasets: closed_general_data,
			});
		}
		if (!onePage || (onePage && /time/.test(path)))
			sheets.push({
				name: 'time',
				x: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('firstResponseActivate'), key: 'agentFirstResponseTimeAfterActivate' },
					{ title: t('firstResponse'), key: 'agentFirstResponseTime' },
					{ title: t('agentChatTime'), key: 'agentChatTime' },
					{ title: t('chatTimeActivate'), key: 'chatTimeAfterActivate' },
				],
				datasets: filterConcatValue,
			});
		if (!onePage || (onePage && /lastmessagedifference/.test(path))) {
			//console.log('LastMessageDifferenceExcelData', LastMessageDifferenceExcelData);
			sheets.push({
				name: 'lastmessagedifference',
				x: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('lastmessageDifference'), key: 'lastmessage_difference' },
					{ title: t('lastmessageDifference_total'), key: 'lastmessage_difference_total' },
				],
				datasets: LastMessageDifferenceExcelData,
			});
		}
		if (ratePoint && (!onePage || (onePage && /rateslist/.test(path)))) {
			sheets.push({
				name: 'rate_list',
				x: [
					{ title: t('email'), key: 'agent' },
					{ title: t('name'), key: 'name' },
					{ title: t('rate'), key: 'rate' },
					{ title: t('topic'), key: 'topic' },
					{ title: t('date'), key: 'date' },
					{ title: t('platform'), key: 'platform' },
					{ title: t('conversation'), key: 'cid' },
					{ title: t('comment'), key: 'comment' },
					{ title: t('selectable_comment'), key: 'selectable_comment' },
				],
				datasets: rateList,
			});
		}
		if (rateComment && (!onePage || (onePage && /ratescomments/.test(path)))) {
			sheets.push({
				name: 'rate_comment_groups',
				x: [
					{ title: t('name'), key: 'name' },
					{ title: t('count'), key: 'count' },
				],
				datasets: excelgroupedRateList,
			});
		}
		//console.log('3');
		/* if (allConversationTable && (!onePage || (onePage && /closedtag/.test(path)))) {
			sheets.push({
				name: 'all_closed_list',
				x: [
					{ title: t('email'), key: 'agent' },
					{ title: t('name'), key: 'name' },
					{ title: t('topic'), key: 'topic' },
					{ title: t('date'), key: 'date' },
					{ title: t('platform'), key: 'platform' },
					{ title: t('conversation'), key: 'cid' },
					{ title: t('agentChatTime'), key: 'agentTime' },
					{ title: t('agentChatTime'), key: 'agentTimeMin' },
				],
				datasets: allClosedData,
			});
		} */
		if (sendProduct && (!onePage || (onePage && /sendingproduct/.test(path)))) {
			sheets.push({
				name: 'sending_product',
				x: [
					{ title: t('email'), key: 'email' },
					{ title: t('name'), key: 'name' },
					{ title: t('total'), key: 'total' },
					{ title: t('productConversation'), key: 'c_total' },
					{ title: t('u_total'), key: 'uniqueProduct' },
					{ title: t('rate'), key: 'rate' },
				],
				datasets: _.filter(sendingData, function (o) {
					return o.email !== 'sephora@yapaytech.com';
				}),
			});
			allX = _.concat(
				allX,
				{ title: t('total'), key: 'send_total' },
				{ title: t('productConversation'), key: 'send_c_total' },
				{ title: t('u_total'), key: 'send_u_total' },
				{ title: t('rate'), key: 'send_rate' }
			);
		}
		if (ecommerce && (!onePage || (onePage && /selling|order/.test(path)))) {
			sheets.push({
				name: 'selling',
				x: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('orderCount'), key: 'sellingCount' },
					{ title: t('productCount'), key: 'productCount' },
					{ title: t('sum'), key: 'sellingSum' },
					{ title: t('average'), key: 'sellingAvg' },
				],
				datasets: sellingConcatValue,
			});
			allX = _.concat(
				allX,
				{ title: t('orderCount'), key: 'sellingCount' },
				{ title: t('productCount'), key: 'productCount' },
				{ title: t('sum'), key: 'sellingSum' },
				{ title: t('average'), key: 'sellingAvg' }
			);
		}
		//console.log('4');
		if (orderCollectaction && (!onePage || (onePage && /selling_collectaction|order_collectaction/.test(path)))) {
			sheets.push({
				name: 'selling_collectaction',
				x: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('orderCount'), key: 'sellingCount' },
					{ title: t('productCount'), key: 'productCount' },
					{ title: t('sum'), key: 'sellingSum' },
					{ title: t('average'), key: 'sellingAvg' },
				],
				datasets: sellingConcatValue,
			});
		}
		//console.log('15');
		if (orderCollectaction && (!onePage || (onePage && /selling_collectaction|order_collectaction/.test(path)))) {
			sheets.push({
				name: 'order_collectaction',
				x: [
					{ title: t('orderCode'), key: 'code' },
					{ title: t('count'), key: 'count' },
					{ title: t('price'), key: 'total' },
					{ title: t('day'), key: 'date' },
					{ title: t('agent'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('phone'), key: 'number' },
					{ title: t('email'), key: 'email' },
					{ title: t('address'), key: 'address' },
					{ title: t('city'), key: 'town' },
					{ title: 'İlçe', key: 'district' },
				],
				datasets: orderCollectactionData,
			});
		}
		/* if (ecommerce) {
			sheets.push({
				name: 'selling_date',
				x: ['date', 'order_count', 'product_count', 'sum', 'avg'],
				datasets: sellingDataDateExcel,
			});
		} */
		if (ecommerce && (!onePage || (onePage && /selling|order/.test(path)))) {
			sheets.push({
				name: 'order_all',
				x: [
					{ title: t('kod'), key: 'kod' },
					{ title: t('id'), key: 'id' },
					{ title: t('count'), key: 'count' },
					{ title: t('sum'), key: 'sum' },
					{ title: t('date'), key: 'date' },
					{ title: t('name'), key: 'name' },
					{ title: t('developer'), key: 'developer' },
					{ title: t('status'), key: 'status' },
				],
				datasets: orderExcelData,
			});
			sheets.push({
				name: 'abondon_baskets',
				x: [
					{ title: t('productCount'), key: 'product_count' },
					{ title: t('price'), key: 'price' },
					{ title: t('date'), key: 'date' },
					{ title: t('user'), key: 'user' },
				],
				datasets: forgottenBasketsExcel,
			});
		}
		//console.log('6');
		if (forwardIntent && (!onePage || (onePage && /intentforward/.test(path)))) {
			let intentForwardData = [];
			if (web_conversations && web_conversations.length) {
				intentForwardData.push({ name: 'Web Bot', count: web_conversations && web_conversations.length });
			}

			_.map(group_by_intent, (it, i) => {
				let intent_info = i.split('_');
				let intent = _.find(intents, (o) => o._id === intent_info[0]);
				let intent_name = (intent && intent.name) || '';
				let buttons = intent && intent.action && intent.action.message && intent.action.message[0] && intent.action.message[0].buttons;
				let button = buttons && buttons.length && intent_info && intent_info[1] && buttons[parseInt(intent_info[1])];

				intentForwardData.push({
					name: i === 'undefined' ? 'Bilgi Yok' : intent ? intent_name + (button ? ` -> ${button.title}` : '') : i,
					count: it.length,
				});
			});
			if (whatsapp_conversations && whatsapp_conversations.length) {
				intentForwardData.push({ name: 'WhatsApp Bot', count: whatsapp_conversations && whatsapp_conversations.length });
			}

			_.map(group_by_intent_whatsapp, (it, i) => {
				let intent_info = i.split('_');
				let intent = _.find(whatsapp_intents, (o) => o._id === intent_info[0]);
				let intent_name = (intent && intent.name) || '';
				let buttons = intent && intent.action && intent.action.message && intent.action.message[0] && intent.action.message[0].buttons;
				let button = buttons && buttons.length && intent_info && intent_info[1] && buttons[parseInt(intent_info[1])];

				intentForwardData.push({
					name: i === 'undefined' ? 'Bilgi Yok' : intent ? intent_name + (button ? ` -> ${button.title}` : '') : i,
					count: it.length,
				});
			});

			sheets.push({
				name: 'intent_forward',
				x: [
					{ title: t('name'), key: 'name' },
					{ title: t('count'), key: 'count' },
				],
				datasets: intentForwardData,
			});
		}

		if (ecommerce && orderCanceledExcelData && orderCanceledExcelData.length && (!onePage || (onePage && /selling|order/.test(path)))) {
			sheets.push({
				name: 'order_canceled',
				x: [
					{ title: t('kod'), key: 'kod' },
					{ title: t('count'), key: 'count' },
					{ title: t('sum'), key: 'sum' },
					{ title: t('date'), key: 'date' },
					{ title: t('name'), key: 'name' },
					{ title: t('developer'), key: 'developer' },
					{ title: t('status'), key: 'status' },
				],
				datasets: orderCanceledExcelData,
			});
		}
		if (ecommerce && orderRefundedExcelData && orderRefundedExcelData.length && (!onePage || (onePage && /selling|order/.test(path)))) {
			sheets.push({
				name: 'order_refunded',
				x: [
					{ title: t('kod'), key: 'kod' },
					{ title: t('count'), key: 'count' },
					{ title: t('sum'), key: 'sum' },
					{ title: t('date'), key: 'date' },
					{ title: t('name'), key: 'name' },
					{ title: t('developer'), key: 'developer' },
					{ title: t('status'), key: 'status' },
				],
				datasets: orderRefundedExcelData,
			});
		}
		if (showTemplate && (!onePage || (onePage && /template/.test(path)))) {
			sheets.push({
				name: 'template',
				x: [
					{ title: t('total'), key: 'total' },
					{ title: t('count'), key: 'count' },
				],
				datasets: [{ total: 'sending', count: templateTotalData }],
			});
		}
		if (generalTable && !onePage) {
			sheets.push({
				name: 'generalTable',
				x: [
					{ title: t('type'), key: 'type' },
					{ title: t('count'), key: 'count' },
				],
				datasets: generalTableData,
			});
			/* console.log('generalGraphDataHourly.excelData', generalGraphDataHourly.excelData); */
			/* sheets.push({
				name: 'generalHourlyGraph',
				x: [
					{ title: t('label'), key: t('label') },
					{ title: t('totalOpenedAllC'), key: t('totalOpenedAllC') },
					{ title: t('totalWaitingAllC'), key: t('totalWaitingAllC') },
					{ title: t('totalContacted'), key: t('totalContacted') },
					{ title: t('dontConnecttedDescription'), key: t('dontConnecttedDescription') },
					{ title: t('totalClosed'), key: t('totalClosed') },
				],
				datasets: generalGraphDataHourly.excelData,
			}); */
			/* console.log('generaldataDayHourly', missing_list); */
			/* sheets.push({
				name: 'generalGraph',
				x: [
					{ title: t('label'), key: t('label') },
					{ title: t('totalOpenedAllC'), key: t('totalOpenedAllC') },
					{ title: t('totalWaitingAllC'), key: t('totalWaitingAllC') },
					{ title: t('totalContacted'), key: t('totalContacted') },
					{ title: t('dontConnecttedDescription'), key: t('dontConnecttedDescription') },
					{ title: t('totalClosed'), key: t('totalClosed') },
				],
				datasets: generaldataDayHourly.excelData,
			}); */
		}
		if (generalTable && (!onePage || (onePage && /missingconversations/.test(path)))) {
			sheets.push({
				name: 'missingConversation',
				x: [
					{ title: t('conversation'), key: 'cid' },
					{ title: t('date'), key: 'date' },
					{ title: 'platform', key: 'platform' },
				],
				datasets: missing_list,
			});
		}
		if (!onePage || (onePage && /timeline/.test(path))) {
			sheets.push({
				name: 'agentTimeline',
				x: [
					{ title: t('agent'), key: 'email' },
					{ title: t('online'), key: 'online_time' },
					{ title: t('offline'), key: 'offline_time' },
					{ title: t('idle_agent'), key: 'idle_time' },
					{ title: t('null'), key: 'null_time' },
				],
				datasets: agent_timeline_exceldata,
			});
		}
		if (conversationGroup && (!onePage || (onePage && /conversationgroup/.test(path)))) {
			sheets.push({
				name: 'conversationGroup',
				x: [
					{ title: '_id', key: '_id' },
					{ title: t('total'), key: 'total' },
				],
				datasets: conversationGroupData,
			});
		}
		if (botConversations && (!onePage || (onePage && /botconversations/.test(path)))) {
			sheets.push({
				name: 'botconversations',
				x: [
					{ title: 'cid', key: 'cid' },
					{ title: t('date'), key: 'date' },
				],
				datasets: botconversations,
			});
		}
		if (stockinfo && (!onePage || (onePage && /stockinfo/.test(path)))) {
			sheets.push({
				name: 'stockWarning',
				x: [
					{ title: t('product_code'), key: 'product_code' },
					{ title: t('product_name'), key: 'product_name' },
					{ title: t('size'), key: 'size' },
					{ title: t('phone'), key: 'phone' },
					{ title: t('date'), key: 'date' },
				],
				datasets: stockresult,
			});
		}
		if (!onePage) sheets.push({ name: 'all', x: allX, datasets: sellingConcatValue });
		let now = moment();
		fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename:
					moment(start_date).format('DD-MM-YYYY_HH:mm') +
					'_' +
					moment(end_date).format('DD-MM-YYYY_HH:mm') +
					'_live_chat_analytic_' +
					pid +
					'_' +
					(onePage ? path : 'all') +
					'_' +
					now.valueOf(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;

				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
			})
			.then(() => {
				this.setState({ buttonLoading: false, excelModal: false, allpage: false });
				this.componentDidMount();
			});
		//console.log('fil', filtervalue);
		filtervalue = [];
	};
	exportExcelHourly = (t, onePage, path) => {
		let value = this.state.productAgentList;
		//console.log('cc', value);
		let product = this.props.product.live;
		let pid = this.state.pid;
		let {
			start_date,
			end_date,
			contactedDataHourly,
			totalAgentClosedDataHourly,
			totalWaitingConvHourly,
			totalOpenedConvHourly,
			totalWaitingConvDayHourly,
			totalOpenedConvDayHourly,
			contactedDataDayHourly,
			totalAgentClosedDataDayHourly,
			rateList,
			excelgroupedRateList,
			allClosedData,
			missing_list,
			intents,
			whatsapp_intents,
			group_by_intent,
			group_by_intent_whatsapp,
			web_conversations,
			whatsapp_conversations,
			agentFirstResponseTimeAfterActivateDataHourly,
			agentFirstResponseTimeAfterActivateDataDayHourly,
			sl_20_grouped,
			sl_30_grouped,
			sl_20_hourly,
			sl_30_hourly,
		} = this.state;
		let ecommerce,
			sendProduct,
			conversationGroup,
			showTemplate,
			ratePoint,
			rateComment,
			generalTable,
			stockinfo,
			allConversationTable,
			orderCollectaction,
			forwardIntent,
			botConversations;
		//timeline = true;
		if (product.settings.analyticView) {
			ecommerce = product.settings.analyticView.ecommerce;
			sendProduct = product.settings.analyticView.sendProduct;
			conversationGroup = product.settings.analyticView.conversationGroup;
			showTemplate = product.settings.analyticView.showTemplate;
			//timeline = product.settings.analyticView.timeline;
			//userlist = product.settings.analyticView.userlist;
			ratePoint = product.settings.analyticView.ratePoint;
			rateComment = product.settings.analyticView.rateComment;
			generalTable = product.settings.analyticView.generalTable;
			stockinfo = product.settings.analyticView.stockinfo;
			allConversationTable = product.settings.analyticView.allConversationTable;
			orderCollectaction = product.settings.analyticView.orderCollectaction;
			forwardIntent = product.settings.analyticView.forwardIntent;
			botConversations = product.settings.analyticView.botConversations;
		}
		let closedTopic = this.state.closedTopicData;
		let closedXAgent = ratePoint
			? [
					{ title: t('developer'), key: 'developer' },
					{ title: t('name'), key: 'name' },
					{ title: t('closed'), key: 'closed' },
					{ title: t('rateCount'), key: 'ratedCount' },
					{ title: t('averageRate'), key: 'avgRate' },
					{ title: '1', key: 'rates_one' },
					{ title: '2', key: 'rates_two' },
					{ title: '3', key: 'rates_three' },
					{ title: '4', key: 'rates_four' },
					{ title: '5', key: 'rates_five' },
			  ]
			: [
					{ title: t('developer'), key: 'developer' },
					{ title: t('closed'), key: 'closed' },
			  ];
		let closedXTopic = ratePoint
			? [
					{ title: t('topic'), key: 'topic' },
					{ title: t('count'), key: 'count' },
					{ title: t('rateCount'), key: 'ratedCount' },
					{ title: t('averageRate'), key: 'avgRate' },
					{ title: '1', key: 'rates_one' },
					{ title: '2', key: 'rates_two' },
					{ title: '3', key: 'rates_three' },
					{ title: '4', key: 'rates_four' },
					{ title: '5', key: 'rates_five' },
			  ]
			: [
					{ title: t('topic'), key: 'topic' },
					{ title: t('count'), key: 'count' },
			  ];
		let sendingData = this.state.sendingData;
		let sellingBotData = this.state.sellingBotData;
		let timeAllExcelData = this.state.timeAllExcelData;
		let forgottenBasketsExcel = this.state.forgottenBasketsExcel;
		let orderExcelData = this.state.orderExcelData;
		//let sellingData = this.state.sellingData;
		let orderCanceledExcelData = this.state.orderCanceledExcelData;
		let orderRefundedExcelData = this.state.orderRefundedExcelData;
		let orderOtherData = this.state.orderOtherData;
		let othersdata = this.state.othersdata;
		let templateTotalData = this.state.templateTotalData;
		let conversationGroupData = this.state.conversationGroupData;
		let orderCollectactionData = this.state.orderCollectactionData;
		let stockresult = this.state.stockresult;
		let agent_timeline_exceldata = this.state.agent_timeline_exceldata;
		let botconversations = this.state.botconversations;
		//let orderExcelDataFiltered = [];
		let generalTableData = [],
			generalGraphDataHourly = [],
			generaldataDayHourly = [];
		let sheets = [];
		if (generalTable && !onePage) {
			/* console.log('contactedDataHourly', contactedDataHourly); */
			generalGraphDataHourly = chartData(
				contactedDataHourly,
				totalAgentClosedDataHourly,
				totalWaitingConvHourly,
				totalOpenedConvHourly,
				start_date,
				end_date,
				t,
				missing_list,
				agentFirstResponseTimeAfterActivateDataHourly,
				this.formatTime,
				sl_20_grouped,
				sl_30_grouped
			);
			generaldataDayHourly = chartDataDayHourly(
				totalWaitingConvDayHourly,
				contactedDataDayHourly,
				totalAgentClosedDataDayHourly,
				totalOpenedConvDayHourly,
				start_date,
				end_date,
				t,
				missing_list,
				agentFirstResponseTimeAfterActivateDataDayHourly,
				this.formatTime,
				sl_20_hourly,
				sl_30_hourly
			);
		}
		if (generalTable && !onePage) {
			sheets.push({
				name: 'generalHourlyGraph',
				x: [
					{ title: t('label'), key: t('label') },
					{ title: t('totalOpenedAllC'), key: t('totalOpenedAllC') },
					{ title: t('totalWaitingAllC'), key: t('totalWaitingAllC') },
					{ title: t('totalContacted'), key: t('totalContacted') },
					{ title: t('dontConnecttedDescription'), key: t('dontConnecttedDescription') },
					{ title: t('totalClosed'), key: t('totalClosed') },
					{ title: 'SL ortalama süresi', key: 'SL ortalama süresi' },
					{ title: 'SL 20', key: 'SL 20' },
					{ title: 'SL 30', key: 'SL 30' },
				],
				datasets: generalGraphDataHourly.excelData,
			});
			sheets.push({
				name: 'generalGraph',
				x: [
					{ title: t('label'), key: t('label') },
					{ title: t('totalOpenedAllC'), key: t('totalOpenedAllC') },
					{ title: t('totalWaitingAllC'), key: t('totalWaitingAllC') },
					{ title: t('totalContacted'), key: t('totalContacted') },
					{ title: t('dontConnecttedDescription'), key: t('dontConnecttedDescription') },
					{ title: t('totalClosed'), key: t('totalClosed') },
					{ title: 'SL Ortalama Süresi', key: 'SL Ortalama Süresi' },
					{ title: 'SL 20', key: 'SL 20' },
					{ title: 'SL 30', key: 'SL 30' },
				],
				datasets: generaldataDayHourly.excelData,
			});
		}

		let now = moment();
		fetch('https://log.yapaytech.com/analytic/download', {
			method: 'POST',
			headers: {
				'Content-Type': 'application/json',
			},
			body: JSON.stringify({
				filename:
					moment(start_date).format('DD-MM-YYYY_HH:mm') +
					'_' +
					moment(end_date).format('DD-MM-YYYY_HH:mm') +
					'_live_chat_analytic_generalTable_' +
					pid +
					'_' +
					(onePage ? path : 'all') +
					'_' +
					now.valueOf(),
				sheets,
			}),
		})
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				let dataurl = data.url;

				var a = document.createElement('a');
				a.href = dataurl;
				a.setAttribute('download', dataurl);
				a.click();
			})
			.then(() => {
				this.setState({ buttonLoading: false, excelModal: false, allpage: false });
				this.componentDidMount();
			});
	};
	socialReportConfig() {
		let analyticView = this.props.product.live.settings.analyticView;
		let config = (analyticView && analyticView.socialReport) || {};
		return {
			label: config.label || 'Sosyal Medya Raporu',
			filename: config.filename || 'social_media_report',
			platforms: config.platforms || ['facebook', 'instagram', 'tiktok'],
			appName: config.appName || 'Uygulama',
			platformNames: config.platformNames || {
				facebook: 'Facebook',
				instagram: 'Instagram',
				tiktok: 'TikTok',
				whatsapp: 'WhatsApp',
				web: 'Web',
			},
			titles: config.titles || {},
		};
	}
	// Sayfa 1 ve 3 için tip bazlı sayımlar, sayfa 2 için konuşma bazlı satırlar tek veri kümesinden çıkar.
	// cid'in select indeksi tipe göre değiştiği için (closed=select4, contacted=select2) iki ayrı sorgu gerekiyor.
	async getSocialReportData() {
		let { pid, productAgentList, closeTags } = this.state;
		let { platforms, appName, titles } = this.socialReportConfig();
		let start_date = moment(this.state.start_date).format();
		let end_date = moment(this.state.end_date).format();
		let request = (suffix, body) =>
			fetch('https://log.yapaytech.com/live/test/getInfo?' + suffix, {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ start_date, end_date, include_hour: true, select: '', options: { sum: 0 }, ...body }),
			})
				.then((response) => response.json())
				.then((response) => response.result || []);

		let [counts, viewedSide, closedSide, contactedSide, openedSide] = await Promise.all([
			// Sayımlar cid'siz alınır; bu sorgu mevcut agent sayfasıyla aynı rakamları verir.
			request('social_report_counts', {
				filter: { type: ['viewed', 'taken', 'contacted', 'closed', 'forwarded'], pid },
				group: ['type', 'agent', 'platform'],
				pairs: { agent: 'select1', platform: 'platform' },
			}),
			// viewed her açılışta arttığı için Okunan tekil konuşma olmalı. cid'i hangi select kolonunda tuttuğu
			// bilinmediğinden adaylar birlikte çekilip bilinen konuşma kimlikleriyle eşleşen seçilir.
			request('social_report_viewed', {
				filter: { type: ['viewed'], pid },
				group: ['type', 'agent', 'platform', 'cid2', 'cid3', 'cid4'],
				pairs: { agent: 'select1', platform: 'platform', cid2: 'select2', cid3: 'select3', cid4: 'select4' },
			}).catch(() => []),
			request('social_report_1', {
				filter: { type: ['taken', 'closed', 'forwarded'], pid },
				group: ['type', 'agent', 'platform', 'cid', 'date', 'topic', 'actor'],
				pairs: { agent: 'select1', cid: 'select4', topic: 'select2', actor: 'select3', platform: 'platform' },
			}),
			request('social_report_2', {
				filter: { type: ['contacted'], pid },
				group: ['type', 'agent', 'platform', 'cid', 'date'],
				pairs: { agent: 'select1', cid: 'select2', platform: 'platform' },
			}),
			// Mesajın geliş anı; agent'ın ilk teması değil. Her konuşmada bulunmayabilir, bulunmazsa ilk temasa düşülür.
			fetch('https://log.yapaytech.com/live/getEvents?social_report_opened', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({ start_date, end_date, filter: { pid, label: 'opened' } }),
			})
				.then((response) => response.json())
				.then((response) => response.result || [])
				.catch(() => []),
		]);
		let openedByCid = _.groupBy(openedSide, 'cid');

		// Raporun kapsamı platformla belirlenir; uygulamadan cevaplananlar (`<pid>-product`) da gerçek bir konuşmadır,
		// ham rapordan düşerlerse Gelen ile satır sayısı tutmuyor. Sadece agent özetinde kişi gibi görünmemeleri gerekir.
		let inScope = (it) => it && !/bot/.test(it.agent || '') && (!platforms.length || _.includes(platforms, it.platform));
		// pid ile başlayan id'ler gerçek agent değil; agent.js'teki `select1 not like '<pid>%'` kuralının aynısı.
		let isAgent = (it) => it && !_.startsWith(it.agent, pid);
		let isReportable = (it) => inScope(it) && isAgent(it);
		let rows = _.filter(_.concat(closedSide, contactedSide), (it) => inScope(it) && it.cid);
		let agentRows = _.filter(rows, isAgent);
		let countRows = _.filter(counts, isReportable);
		let sumCount = (items, type) => _.sumBy(_.filter(items, { type }), (it) => it.count || 0);

		let viewedRows = _.filter(viewedSide, isReportable);
		let knownCids = _.keyBy(rows, 'cid');
		let matchCount = (field) => _.filter(viewedRows, (it) => it[field] && knownCids[it[field]]).length;
		let bestField = _.maxBy(['cid4', 'cid2', 'cid3'], matchCount);
		// Hiçbir aday bilinen konuşmalarla eşleşmiyorsa tekil sayım güvenilir değil, sayıma düşülür.
		let viewedCidField = bestField && matchCount(bestField) ? bestField : null;
		// `viewed` yalnızca konuşmaya kendi tıklayanda yazılıyor, aktarma yoluyla gelende yazılmıyor: canlıda bir
		// agent 29 konuşma kapatıp sadece 8 viewed almıştı. Bu yüzden Okunan, görüntülemenin yanı sıra üzerine
		// gelen/dokunulan konuşmaları da kapsar — cevaplayan ya da kapatan tanımı gereği okumuştur.
		let readTypes = ['taken', 'contacted', 'closed'];
		let readCids = (filter) =>
			_.uniq(
				_.compact(
					_.concat(
						_.map(_.filter(viewedRows, filter), viewedCidField),
						_.map(_.filter(agentRows, (it) => _.includes(readTypes, it.type) && (!filter || _.isMatch(it, filter))), 'cid')
					)
				)
			);

		let conversations = _.map(_.groupBy(rows, 'cid'), (items, cid) => {
			let byTime = _.sortBy(items, (it) => moment(it.date).valueOf());
			let first = byTime[0];
			let takenRow = _.find(byTime, { type: 'taken' });
			let contactedRow = _.find(byTime, { type: 'contacted' });
			let closedRow = _.find(byTime, { type: 'closed' });
			let ownerRow = contactedRow || takenRow || closedRow || first;
			let agent = _.find(productAgentList, { id: ownerRow.agent });
			let byApp = !isAgent(ownerRow);
			let topic = closedRow && _.find(closeTags, { id: closedRow.topic });
			let openedEvent = _.minBy(openedByCid[cid], (it) => moment(it.created_at).valueOf());
			let incoming = openedEvent ? moment(openedEvent.created_at) : moment(first.date);
			let answered = contactedRow && moment(contactedRow.date);
			return {
				cid,
				platform: first.platform,
				agent_id: ownerRow.agent,
				developer: byApp ? appName : (agent && agent.developer) || ownerRow.agent,
				name: byApp ? appName : (agent && agent.name) || '',
				incoming_date: incoming.format('DD-MM-YYYY'),
				incoming_time: incoming.format('HH:mm:ss'),
				answer_date: answered ? answered.format('DD-MM-YYYY') : '',
				answer_time: answered ? answered.format('HH:mm:ss') : '',
				answer_duration: answered ? this.formatTime(answered.diff(incoming)) : '',
				status: closedRow ? 'Kapalı' : 'Açık',
				topic: (topic && topic.title) || (closedRow && closedRow.topic) || '',
				answer_ms: answered ? answered.diff(incoming) : null,
				incoming_ms: incoming.valueOf(),
				closed: closedRow ? 1 : 0,
			};
		});

		let viewedOf = (platform, agentId) => {
			let filter = platform ? { platform } : { agent: agentId };
			// cid kolonu çözülemediyse tekil sayım güvenilir değil, ham sayıma düşülür.
			return viewedCidField ? readCids(filter).length : sumCount(_.filter(countRows, filter), 'viewed');
		};
		// Gelen, agent'ın ele aldığı konuşmalarla sınırlı kalmamalı: sadece görüntülenip bırakılanlar da sayılır,
		// aksi halde Okunan Gelen'i aşabiliyor.
		let incomingCount = (platform) => {
			let seen = _.map(_.filter(conversations, { platform }), 'cid');
			if (viewedCidField) seen = _.concat(seen, _.map(_.filter(viewedRows, { platform }), viewedCidField));
			return _.uniq(_.compact(seen)).length;
		};
		let platformSummary = _.map(platforms, (platform) => {
			let closed = _.sumBy(_.filter(conversations, { platform }), 'closed');
			let total = incomingCount(platform);
			return {
				platform,
				total,
				viewed: viewedOf(platform),
				closed,
				open: total - closed,
			};
		});
		platformSummary.push({
			platform: 'TOPLAM',
			total: _.sumBy(platformSummary, 'total'),
			viewed: _.sumBy(platformSummary, 'viewed'),
			closed: _.sumBy(platformSummary, 'closed'),
			open: _.sumBy(platformSummary, 'open'),
		});

		let averageDuration = (items) => {
			let answered = _.filter(items, (it) => it.answer_ms !== null);
			return answered.length ? this.formatTime(_.sumBy(answered, 'answer_ms') / answered.length) : '';
		};
		// Agent satırları da tekil konuşma sayar: aynı konuşmayı 4 kez kapatmak 4 kapatma değildir.
		let distinctCids = (items, predicate) => _.uniq(_.compact(_.map(_.filter(items, predicate), 'cid'))).length;
		// Aktarma anında sistem konuşmayı hedefe otomatik `taken` olarak yazıyor (canlıda aynı saniye içinde).
		// Bu gerçek bir katılım değil, atamadır; Katılınan'dan düşülür, "Kendisine Aktarılan" kolonunda görünür.
		let forwardsTo = _.groupBy(_.filter(rows, { type: 'forwarded' }), (it) => it.cid + '|' + it.agent);
		let isAutoTaken = (it) =>
			_.some(forwardsTo[it.cid + '|' + it.agent], (fw) => Math.abs(moment(fw.date).diff(moment(it.date))) <= 5000);
		let joinedCids = (items) => distinctCids(items, (it) => it.type === 'taken' && !isAutoTaken(it));

		let agentIds = _.uniq(_.compact(_.concat(_.map(agentRows, 'agent'), _.map(viewedRows, 'agent'))));
		let agentSummary = _.map(agentIds, (agentId) => {
			let agent = _.find(productAgentList, { id: agentId });
			let items = _.filter(agentRows, { agent: agentId });
			return {
				developer: (agent && agent.developer) || agentId,
				name: (agent && agent.name) || '',
				viewed: viewedOf(null, agentId),
				taken: joinedCids(items),
				contacted: distinctCids(items, { type: 'contacted' }),
				closed: distinctCids(items, { type: 'closed' }),
				forwarded: distinctCids(rows, (it) => it.type === 'forwarded' && it.actor === agentId),
				received: distinctCids(items, { type: 'forwarded' }),
				avg_answer_duration: averageDuration(_.filter(conversations, { agent_id: agentId })),
			};
		});
		// İki ayrı soru, iki ayrı satır: kolon toplamı kişilerin iş yükünü, tekil sayı kaç konuşma olduğunu verir.
		// Aynı konuşmaya birden çok agent dokunduğu için ikisi eşit değil (ör. kapatılan 99 vs 97) — tek satır
		// yazınca biri hep eksik ya da fazla görünüyor. Süre toplanabilir bir değer olmadığı için burada boş.
		agentSummary.push({
			developer: titles.sumRow || 'TOPLAM (agent toplamı)',
			name: '',
			viewed: _.sumBy(agentSummary, 'viewed'),
			taken: _.sumBy(agentSummary, 'taken'),
			contacted: _.sumBy(agentSummary, 'contacted'),
			closed: _.sumBy(agentSummary, 'closed'),
			forwarded: _.sumBy(agentSummary, 'forwarded'),
			received: _.sumBy(agentSummary, 'received'),
			avg_answer_duration: '',
		});
		// Sayfa 1 ile birebir tutan satır: her konuşma bir kez sayılır.
		agentSummary.push({
			developer: titles.allRow || 'TEKİL KONUŞMA SAYISI',
			name: '',
			viewed: viewedCidField ? readCids().length : sumCount(countRows, 'viewed'),
			taken: joinedCids(agentRows),
			contacted: distinctCids(agentRows, { type: 'contacted' }),
			closed: distinctCids(agentRows, { type: 'closed' }),
			forwarded: distinctCids(rows, (it) => it.type === 'forwarded' && it.actor && isAgent({ agent: it.actor })),
			received: distinctCids(agentRows, { type: 'forwarded' }),
			avg_answer_duration: averageDuration(conversations),
		});

		return { conversations: _.sortBy(conversations, 'incoming_ms'), platformSummary, agentSummary };
	}
	exportSocialReport = async (t) => {
		this.setState({ buttonLoading: true });
		let { pid, start_date, end_date } = this.state;
		let { label, filename, platformNames, titles } = this.socialReportConfig();
		let title = (key, fallback) => titles[key] || fallback;
		try {
			let { conversations, platformSummary, agentSummary } = await this.getSocialReportData();
			let sheets = [
				{
					name: title('summarySheet', 'DM & Yorum Raporu'),
					x: [
						{ title: title('channel', 'Sosyal Medya Kanalı'), key: 'platform' },
						{ title: title('incoming', 'Gelen DM & Yorum Sayısı'), key: 'total' },
						{ title: title('read', 'Okunan DM & Yorum Sayısı'), key: 'viewed' },
						{ title: title('closed', 'Kapalı DM & Yorum Sayısı'), key: 'closed' },
						{ title: title('open', 'Açık DM & Yorum Sayısı'), key: 'open' },
					],
					datasets: _.map(platformSummary, (it) => ({ ...it, platform: platformNames[it.platform] || it.platform })),
				},
				{
					name: title('rawSheet', 'Cevaplanan Ham Rapor'),
					x: [
						{ title: title('incomingDate', 'DM & Yorum Tarihi'), key: 'incoming_date' },
						{ title: title('incomingTime', 'DM & Yorum Saati'), key: 'incoming_time' },
						{ title: title('answerDate', 'Cevap Verme Tarihi'), key: 'answer_date' },
						{ title: title('answerTime', 'Cevap Verme Saati'), key: 'answer_time' },
						{ title: title('answerDuration', 'Cevap Verme Süresi'), key: 'answer_duration' },
						{ title: title('agentName', 'Agent Adı'), key: 'name' },
						{ title: title('status', 'DM & Yorum Statüsü ( Açık - Kapalı )'), key: 'status' },
						{ title: title('tag', 'Etiket İsmi'), key: 'topic' },
						{ title: title('cid', 'Konuşma'), key: 'cid' },
					],
					datasets: conversations,
				},
				{
					name: title('agentSheet', 'Agent Özet Rapor'),
					x: [
						{ title: title('person', 'Kişi'), key: 'developer' },
						{ title: title('name', 'İsim'), key: 'name' },
						{ title: title('read', 'Okunan DM & Yorum Sayısı'), key: 'viewed' },
						{ title: title('joined', 'Katılınan DM & Yorum Sayısı'), key: 'taken' },
						{ title: title('answered', 'Cevaplanan DM & Yorum Sayısı'), key: 'contacted' },
						{ title: title('closedByAgent', 'Kapatılan DM & Yorum Sayısı'), key: 'closed' },
						{ title: title('forwarded', 'Aktarılan DM & Yorum Sayısı'), key: 'forwarded' },
						{ title: title('received', 'Kendisine Aktarılan DM & Yorum Sayısı'), key: 'received' },
						{ title: title('avgAnswerDuration', 'Ortalama Cevaplama Süresi'), key: 'avg_answer_duration' },
					],
					datasets: agentSummary,
				},
			];
			let response = await fetch('https://log.yapaytech.com/analytic/download', {
				method: 'POST',
				headers: {
					'Content-Type': 'application/json',
				},
				body: JSON.stringify({
					filename:
						moment(start_date).format('DD-MM-YYYY_HH:mm') +
						'_' +
						moment(end_date).format('DD-MM-YYYY_HH:mm') +
						'_' +
						filename +
						'_' +
						pid +
						'_' +
						moment().valueOf(),
					sheets,
				}),
			}).then((it) => it.json());
			var a = document.createElement('a');
			a.href = response.url;
			a.setAttribute('download', response.url);
			a.click();
			this.setState({ buttonLoading: false, excelModal: false });
		} catch (e) {
			console.error(label, e);
			this.setState({ buttonLoading: false });
		}
	};
	render() {
		const { t, i18n } = this.props;
		//moment.locale(selectedLang);
		if (this.state.loading)
			return (
				<Page title={t('analytic')} icon="chart bar">
					<Page.Loader></Page.Loader>
				</Page>
			);
		let ecommerce,
			sendProduct,
			conversationGroup,
			showTemplate,
			timeline,
			userlist,
			stockinfo,
			timeSelect,
			ratePoint,
			generalTable,
			orderCollectaction,
			rateComment,
			forwardIntent,
			botConversations,
			raw_analytic,
			socialReport,
			sendMailFormat = false;
		timeline = true;
		if (this.props.product.live.settings.analyticView) {
			ecommerce = this.props.product.live.settings.analyticView.ecommerce;
			sendProduct = this.props.product.live.settings.analyticView.sendProduct;
			conversationGroup = this.props.product.live.settings.analyticView.conversationGroup;
			showTemplate = this.props.product.live.settings.analyticView.showTemplate;
			//timeline = this.props.product.live.settings.analyticView.timeline;
			userlist = this.props.product.live.id === '50e60eb9-7469-474a-8204-d246ef3851a2'; //false; // this.props.product.live.settings.analyticView.userlist;
			stockinfo = this.props.product.live.settings.analyticView.stockinfo;
			timeSelect = this.props.product.live.settings.analyticView.timeSelect;
			ratePoint = this.props.product.live.settings.analyticView.ratePoint;
			rateComment = this.props.product.live.settings.analyticView.rateComment;
			generalTable = this.props.product.live.settings.analyticView.generalTable;
			orderCollectaction = this.props.product.live.settings.analyticView.orderCollectaction;
			sendMailFormat = this.props.product.live.settings.analyticView.sendMailFormat;
			forwardIntent = this.props.product.live.settings.analyticView.forwardIntent;
			botConversations = this.props.product.live.settings.analyticView.botConversations;
			raw_analytic = this.props.product.live.settings.analyticView.raw_analytic;
			socialReport = this.props.product.live.settings.analyticView.socialReport;
		}
		let { start_date, end_date, buttonLoading, start_time, end_time, agent_statuses } = this.state;
		let noMinDate = this.props.product && this.props.product.live && this.props.product.live.settings && this.props.product.live.settings.noMinDate;
		let maxThreeMonths =
			this.props.product &&
			this.props.product.live &&
			this.props.product.live.settings &&
			this.props.product.live.settings.analyticView &&
			this.props.product.live.settings.analyticView.maxThreeMonths;
		let ownerName =
			this.props && this.props.access && this.props.access.user && this.props.access.user.loggedUserObj && this.props.access.user.loggedUserObj.name;
		/* let ownerMail =
			this.props && this.props.access && this.props.access.user && this.props.access.user.loggedUserObj && this.props.access.user.loggedUserObj.email; */
		let newList = this.state.newList;
		let openPopup = this.state.openPopup;
		let productAgentList = this.state.productAgentList;
		let productOldAgentList = this.state.productOldAgentList;
		_.map(productAgentList, function (it, i) {
			let name = _.find(newList, { email: it.developer }) && _.find(newList, { email: it.developer }).name;
			if (i === 0) {
				return (it.name = ownerName || it.developer);
			}
			return (it.name = name ? name : it.developer);
		});
		let selectedLang = (i18n && i18n.languages && i18n.languages[0]) || 'en';
		let path = window.location.pathname;
		let isTimeSelectPage =
			/agent|closedtag|time|sendingproduct|order|selling|missingconversations|closedgeneral|rateslist|ratescomments|lastmessagedifference/.test(path);
		let isPlatform = /agentautocheck/.test(path);
		let platformList = [
			{
				text: t('allPlatforms'),
				value: 'all',
			},
			{
				text: 'WhatsApp',
				value: 'whatsapp',
			},
			{
				text: 'Facebook',
				value: 'facebook',
			},
			{
				text: 'Instagram',
				value: 'instagram',
			},
			{
				text: 'Telegram',
				value: 'telegram',
			},
			{
				text: 'Web',
				value: 'web',
			},
		];
		if (this.props.product.live.id === '50e60eb9-7469-474a-8204-d246ef3851a2')
			platformList = [
				{
					text: t('allPlatforms'),
					value: 'all',
				},
				{
					text: 'WhatsApp',
					value: 'whatsapp',
				},
				{
					text: 'Facebook',
					value: 'facebook',
				},
				{
					text: 'Instagram',
					value: 'instagram',
				},
				{
					text: 'Flo',
					value: 'web',
				},
				{
					text: 'Instreet',
					value: 'instreet',
				},
			];
		return (
			<Page title={t('analytic')} icon="chart bar" data={this.props}>
				<Page.Wrap>
					<Menu className="settings" pointing secondary stackable>
						<Menu.Item as={NavLink} exact to="/analytic/agent">
							<Icon name="user" />
							{t('agent')}
						</Menu.Item>
						{generalTable && (
							<Menu.Item as={NavLink} exact to="/analytic/missingconversations">
								<Icon name="dont" />
								{t('dontConnectted')}
							</Menu.Item>
						)}
						{botConversations ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/botconversations">
									<Icon name="conversation" />
									Bot Konuşmaları
								</Menu.Item>
							</>
						) : (
							''
						)}
						<Menu.Item as={NavLink} exact to="/analytic/closedtag">
							<Icon name="window close" />
							{t('closeTag')}
						</Menu.Item>
						<Menu.Item as={NavLink} exact to="/analytic/closedgeneral">
							<Icon name="window close" />
							{t('closeGeneral')}
						</Menu.Item>
						{ratePoint && (
							<Menu.Item as={NavLink} exact to="/analytic/rateslist">
								<Icon name="star" />
								{t('rateslist')}
							</Menu.Item>
						)}
						{rateComment && (
							<Menu.Item as={NavLink} exact to="/analytic/ratescomments">
								<Icon name="comments" />
								{t('ratesComments')}
							</Menu.Item>
						)}
						{forwardIntent && (
							<Menu.Item as={NavLink} exact to="/analytic/intentforward">
								<Icon name="exchange" />
								{t('intentforward')}
							</Menu.Item>
						)}
						<Menu.Item as={NavLink} exact to="/analytic/time">
							<Icon name="time" />
							{t('times')}
						</Menu.Item>
						<Menu.Item as={NavLink} exact to="/analytic/lastmessagedifference">
							<Icon name="time" />
							{t('lastmessagedifference')}
						</Menu.Item>
						{timeline && this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/timeline">
									<Icon name="bars" />
									{t('timeline')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{raw_analytic && this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/rawanalytic">
									<Icon name="bars" />
									Genel Analitik
								</Menu.Item>
							</>
						) : (
							''
						)}
						{agent_statuses && this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/agentstatustimeline">
									<Icon name="bars" />
									{t('timelinetuslama')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{agent_statuses && this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/agentautocheck">
									<Icon name="bars" />
									Dağıtım Kontrol
								</Menu.Item>
							</>
						) : (
							''
						)}
						{userlist && this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/userlist">
									<Icon name="users" />
									{t('usersInfo')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{conversationGroup ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/conversationgroup">
									<Icon name="conversation" />
									{t('conversationGroup')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{sendProduct ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/sendingproduct">
									<Icon name="send" />
									{t('sendingProduct')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{ecommerce ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/selling">
									<Icon name="shopping cart" />
									{t('selling')}
								</Menu.Item>
								<Menu.Item as={NavLink} exact to="/analytic/order">
									<Icon name="ordered list" />
									{t('order')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{orderCollectaction ? (
							<Menu.Item as={NavLink} exact to="/analytic/selling_collectaction">
								<Icon name="ordered list" />
								{t('selling')}
							</Menu.Item>
						) : (
							''
						)}
						{orderCollectaction ? (
							<Menu.Item as={NavLink} exact to="/analytic/order_collectaction">
								<Icon name="ordered list" />
								{t('order')}
							</Menu.Item>
						) : (
							''
						)}
						{stockinfo ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/stockinfo">
									<Icon name="ordered list" />
									{t('StockInfo')}
								</Menu.Item>
								<Menu.Item as={NavLink} exact to="/analytic/eventtable">
									<Icon name="ordered list" />
									{t('event')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{showTemplate ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/template">
									<Icon name="whatsapp" />
									{t('Template')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{this.state.agent_role !== 'agent' ? (
							<>
								<Menu.Item as={NavLink} exact to="/analytic/dashboard">
									<Icon name="table" />
									{t('dashboard')}
								</Menu.Item>
								<Menu.Item as={NavLink} exact to="/analytic/archive">
									<Icon name="archive" />
									{t('archive')}
								</Menu.Item>
							</>
						) : (
							''
						)}
						{sendMailFormat && (
							<Menu.Item as={NavLink} exact to="/analytic/mail">
								<Icon name="mail" />
								Email
							</Menu.Item>
						)}
						{/* <Menu.Item as={NavLink} exact to="/analytic/randevu">
								<Icon name="conversation" />
								Appointment
							</Menu.Item> */}
					</Menu>
					<div style={{ display: 'flex' }}>
						<div style={{ display: 'flex', alignItems: 'center', marginLeft: 'auto', marginRight: '20px' }}>
							<Radio toggle label={t('displayName')} onChange={this.toggleName}></Radio>
						</div>
						{/* 	{isPlatform && (
							<div>
								<Dropdown
									selection
									options={platformList}
									value={selectedPlatform}
									name="selectedPlatform"
									onChange={(e, { name, value }) => this.setState({ selectedPlatform: value })}
								></Dropdown>
							</div>
						)} */}
						{!isPlatform && (
							<Popup
								trigger={
									<Button
										primary
										style={{ marginRight: '10px' }}
										content={`${moment(start_date).locale(selectedLang).format('MMM DD, YYYY')} - ${moment(end_date)
											.locale(selectedLang)
											.format('MMM DD, YYYY')}`}
										floated="right"
										onClick={() => this.setState({ openPopup: true })}
									/>
								}
								content={
									<Picker
										maxThreeMonths={/userlist/.test(path) && maxThreeMonths}
										dateChange={this.dateChange}
										startDate={start_date.toDate()}
										endDate={end_date.toDate()}
										lang={selectedLang}
										timeChangeStart={this.timeChangeStart}
										timeChangeEnd={this.timeChangeEnd}
										startTime={start_time}
										endTime={end_time}
										timeSelect={timeSelect}
										isTimeSelectPage={isTimeSelectPage}
										noMinDate={noMinDate}
										getNewData={this.getNewData}
									/>
								}
								on="click"
								position="bottom right"
								onClose={() => this.setState({ openPopup: false })}
								open={openPopup}
							/>
						)}
						{this.state.agent_role !== 'agent' ? (
							<Button
								style={{ margin: '0', minWidth: '35px', minHeight: '38px', padding: '5px' }}
								color="green"
								icon
								//loading={buttonLoading}
								onClick={() => this.setState({ excelModal: true })}
								//onClick={() => this.createExcelData(productAgentList, t, productOldAgentList, false)}
							>
								{/* <Icon name="file excel"></Icon> */}
								{!buttonLoading ? <img src="/icons/excel-white.png" alt="" width="25px" /> : <Icon width="25px" loading name="spinner" />}
							</Button>
						) : (
							''
						)}
						<Modal closeIcon onClose={() => this.setState({ excelModal: false, allpage: false })} open={this.state.excelModal} size="small">
							<Modal.Content style={{ textAlign: 'center' }}>
								<h4>Seçili tarihler arasını excel olarak indirmek istediğinize emin misiniz?</h4>
								{/* <Button
									color="green"
									inverted
									loading={buttonLoading}
									onClick={() => this.createExcelData(productAgentList, t, productOldAgentList, false)}
								>
									{t('downloadAllPages')}
								</Button> */}
								{!/dashboard/.test(path) && (
									<Checkbox
										style={{ marginRight: '10px' }}
										label={t('downloadAllPages')}
										checked={this.state.allpage}
										onChange={() => this.setState({ allpage: !this.state.allpage })}
									></Checkbox>
								)}
							</Modal.Content>
							<Modal.Actions style={{ display: 'flex', justifyContent: 'center' }}>
								<Button
									color="green"
									inverted
									loading={buttonLoading}
									onClick={() =>
										this.createExcelData(productAgentList, t, productOldAgentList, /dashboard/.test(path) ? false : !this.state.allpage)
									}
								>
									{t('downloadExcel')}
								</Button>
								<Button
									color="green"
									inverted
									loading={buttonLoading}
									onClick={() =>
										this.createExcelDataHourly(
											productAgentList,
											t,
											productOldAgentList,
											/dashboard/.test(path) ? false : !this.state.allpage
										)
									}
								>
									{t('downloadExcelOnlyHourly')}
								</Button>
								{socialReport && (
									<Button color="green" inverted loading={buttonLoading} onClick={() => this.exportSocialReport(t)}>
										{this.socialReportConfig().label}
									</Button>
								)}
							</Modal.Actions>
						</Modal>
					</div>
				</Page.Wrap>
				<Switch>
					{this.state.agent_role !== 'agent' ? (
						<Route
							path="/analytic/dashboard"
							render={() => (
								<Dashboard
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}

					<Route
						path="/analytic/time"
						render={() => (
							<Time
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/rawanalytic"
						render={() => (
							<RawAnalytic
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/closedtag"
						render={() => (
							<Closed
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/closedgeneral"
						render={() => (
							<ClosedFrequency
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/rateslist"
						render={() => (
							<RatesList
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					{rateComment && (
						<Route
							path="/analytic/ratescomments"
							render={() => (
								<RatesComments
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					)}
					{forwardIntent && (
						<Route
							path="/analytic/intentforward"
							render={() => (
								<IntentForward
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					)}
					{botConversations && (
						<Route
							path="/analytic/botconversations"
							render={() => (
								<BotConversations
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					)}
					<Route
						path="/analytic/missingconversations"
						render={() => (
							<MissingConversationTable
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/agent"
						render={() => (
							<Agent
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					{sendProduct ? (
						<Route
							path="/analytic/sendingproduct"
							render={() => (
								<SendingProduct
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{orderCollectaction ? (
						<Route
							path="/analytic/order_collectaction"
							render={() => (
								<OrderCollectaction
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{orderCollectaction ? (
						<Route
							path="/analytic/selling_collectaction"
							render={() => (
								<SellingCollectaction
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}

					{ecommerce ? (
						<Route
							path="/analytic/order"
							render={() => (
								<Order
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{ecommerce ? (
						<Route
							path="/analytic/selling"
							render={() => (
								<Selling
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{stockinfo ? (
						<Route
							path="/analytic/stockinfo"
							render={() => (
								<StockInfo
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{true || showTemplate ? (
						<Route
							path="/analytic/template"
							render={() => (
								<Template
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					{stockinfo ? (
						<Route
							path="/analytic/eventtable"
							render={() => (
								<EventTable
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}

					{true || conversationGroup ? (
						<Route
							path="/analytic/conversationgroup"
							render={() => (
								<ConversationGroup
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						''
					)}
					<Route
						path="/analytic/generalagenttable"
						render={() => (
							<GeneralAgentTable
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					{this.state.agent_role !== 'agent' ? (
						<Route
							path="/analytic/userlist"
							render={() => (
								<UserList
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : null}

					{timeline && this.state.agent_role !== 'agent' ? (
						<Route
							path="/analytic/timeline"
							render={() => (
								<Timeline
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : null}
					{agent_statuses && this.state.agent_role !== 'agent' ? (
						<Route
							path="/analytic/agentstatustimeline"
							render={() => (
								<AgentStatusTimeline
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : null}
					<Route
						path="/analytic/lastmessagedifference"
						render={() => (
							<LastMessageDifference
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/agentstatuscurrent"
						render={() => (
							<AgentStatusCurrent
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/agentautocheck"
						render={() => (
							<AgentAutoCheck
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={moment().add(-1, 'd').startOf('day')}
								end_date={moment().add(-1, 'd').endOf('day')}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					<Route
						path="/analytic/archive"
						render={() => (
							<ArchiveTab
								selectedPlatform={this.state.selectedPlatform}
								platformList={platformList}
								start_date={this.state.start_date}
								end_date={this.state.end_date}
								displayName={this.state.displayName}
								newDataToggle={this.state.newDataToggle}
							/>
						)}
					/>
					{sendMailFormat && (
						<Route
							path="/analytic/mail"
							render={() => (
								<SendMailTab
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					)}
					{/* <Route
						to="/analytic/randevu"
						render={() => <Randevu selectedPlatform={this.state.selectedPlatform}
						platformList={platformList}start_date={this.state.start_date} end_date={this.state.end_date} displayName={this.state.displayName} />}
					/> */}
					{this.state.agent_role !== 'agent' ? (
						<Redirect
							to="/analytic/dashboard"
							render={() => (
								<Dashboard
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					) : (
						<Redirect
							to="/analytic/agent"
							render={() => (
								<Agent
									selectedPlatform={this.state.selectedPlatform}
									platformList={platformList}
									start_date={this.state.start_date}
									end_date={this.state.end_date}
									displayName={this.state.displayName}
									newDataToggle={this.state.newDataToggle}
								/>
							)}
						/>
					)}
				</Switch>
			</Page>
		);
	}
}
// date array
var getDateArray = function (start, end) {
	var arr = [],
		dt = new Date(start);

	while (dt <= end) {
		arr.push(new Date(dt));
		dt.setDate(dt.getDate() + 1);
	}

	return arr;
};
var getHourArray = function (start, end) {
	var arr = [],
		dt = 0;

	while (dt < 24) {
		arr.push(dt);
		dt++;
	}
	return arr;
};
function chartData(
	contactedDataHourly,
	totalAgentClosedDataHourly,
	totalWaitingConvHourly,
	totalOpenedConvHourly,
	start_date,
	end_date,
	t,
	missing_list,
	agentFirstResponseTimeAfterActivateDataHourly,
	formatTime,
	sl_20_grouped,
	sl_30_grouped
) {
	//console.log('agentFirstResponseTimeAfterActivateDataHourly', totalAgentClosedDataHourly, agentFirstResponseTimeAfterActivateDataHourly);
	// Tarihleri baştan hesaplayalım
	const startDate = new Date(start_date);
	const endDate = new Date(end_date);

	// Saatleri önceden hesaplayalım
	const hourArr = Array.from({ length: 24 }, (_, i) => i);

	// Tarih aralığını hesaplayalım
	const dateArr = [];
	const currentDate = new Date(startDate);
	while (currentDate <= endDate) {
		dateArr.push(new Date(currentDate));
		currentDate.setDate(currentDate.getDate() + 1);
	}

	// Label'ları tek seferde oluşturalım
	const labels = dateArr.flatMap((date) => hourArr.map((hour) => `${moment(date).format('DD/MM')} - ${moment().hour(hour).format('HH')}`));

	// Veri dizilerini önceden oluşturalım
	const dataArrays = {
		contacted: new Array(labels.length).fill(0),
		closed: new Array(labels.length).fill(0),
		waiting: new Array(labels.length).fill(0),
		opened: new Array(labels.length).fill(0),
		firstMessage: new Array(labels.length).fill(0),
		missing: new Array(labels.length).fill(0),
		agentFirstResponseTimeAfterActivate: new Array(labels.length).fill(0),
		sl_20: new Array(labels.length).fill(0),
		sl_30: new Array(labels.length).fill(0),
	};

	// Veriyi tek döngüde işleyelim
	dateArr.forEach((date, dateIndex) => {
		const dayOfYear = moment(date).dayOfYear();

		hourArr.forEach((hour, hourIndex) => {
			const index = dateIndex * 24 + hourIndex;

			// Missing list işleme
			const missingCount = missing_list.filter(
				(o) => moment(o.date, 'DD-MM-YYYY HH:mm:ss').dayOfYear() === dayOfYear && moment(o.date, 'DD-MM-YYYY HH:mm:ss').hour() === hour
			).length;
			dataArrays.missing[index] = missingCount;

			// Waiting conversations
			const waitingConv = totalWaitingConvHourly.find((o) => moment(o.date).dayOfYear() === dayOfYear && moment(o.date).hour() === hour);
			dataArrays.waiting[index] = (waitingConv && waitingConv.count) || 0;

			// Opened conversations
			const openedConv = totalOpenedConvHourly.find((o) => moment(o.date).dayOfYear() === dayOfYear && moment(o.date).hour() === hour);
			dataArrays.opened[index] = (openedConv && openedConv.cid_count) || 0;

			// Contacted data
			const contactedData = contactedDataHourly && contactedDataHourly[dayOfYear] && contactedDataHourly[dayOfYear].filter((item) => item.hour === hour);
			dataArrays.contacted[index] = contactedData ? contactedData.reduce((sum, item) => sum + parseInt(item.len), 0) : 0;

			// Closed data
			const closedData =
				totalAgentClosedDataHourly &&
				totalAgentClosedDataHourly[dayOfYear] &&
				totalAgentClosedDataHourly[dayOfYear].filter((item) => item.hour === hour);
			dataArrays.closed[index] = closedData ? closedData.reduce((sum, item) => sum + parseInt(item.len), 0) : 0;

			const sl_20Data = sl_20_grouped && sl_20_grouped[dayOfYear] && sl_20_grouped[dayOfYear].filter((item) => item.hour === hour);
			dataArrays.sl_20[index] = sl_20Data ? sl_20Data.reduce((sum, item) => sum + parseInt(item.len), 0) : 0;

			const sl_30Data = sl_30_grouped && sl_30_grouped[dayOfYear] && sl_30_grouped[dayOfYear].filter((item) => item.hour === hour);
			dataArrays.sl_30[index] = sl_30Data ? sl_30Data.reduce((sum, item) => sum + parseInt(item.len), 0) : 0;

			// Agent first response time data
			const agentFirstResponseTimeAfterActivateData =
				agentFirstResponseTimeAfterActivateDataHourly &&
				agentFirstResponseTimeAfterActivateDataHourly[dayOfYear] &&
				agentFirstResponseTimeAfterActivateDataHourly[dayOfYear].filter((item) => item.hour === hour);
			//console.log('agentFirstResponseTimeAfterActivateData', agentFirstResponseTimeAfterActivateData);
			dataArrays.agentFirstResponseTimeAfterActivate[index] =
				agentFirstResponseTimeAfterActivateData && agentFirstResponseTimeAfterActivateData[0]
					? formatTime(agentFirstResponseTimeAfterActivateData[0].avg)
					: '-';
		});
	});
	//console.log('dataArrays', dataArrays);
	// Dataset'leri oluşturalım
	const datasets = [
		{
			label: t('totalWaitingAllC'),
			data: dataArrays.waiting,
			borderColor: 'orange',
			backgroundColor: 'orange',
			fill: false,
		},
		{
			label: t('totalOpenedAllC'),
			data: dataArrays.opened,
			borderColor: 'pink',
			backgroundColor: 'pink',
			fill: false,
		},
		{
			label: t('totalFirstMessageAllC'),
			data: dataArrays.firstMessage,
			borderColor: 'purple',
			backgroundColor: 'purple',
			fill: false,
		},
		{
			label: t('totalContacted'),
			data: dataArrays.contacted,
			borderColor: 'blue',
			backgroundColor: 'blue',
			fill: false,
		},
		{
			label: t('dontConnecttedDescription'),
			data: dataArrays.missing,
			borderColor: 'red',
			backgroundColor: 'red',
			fill: false,
		},
		{
			label: t('totalClosed'),
			data: dataArrays.closed,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		{
			label: 'SL ortalama süresi',
			data: dataArrays.agentFirstResponseTimeAfterActivate,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		{
			label: 'SL 20',
			data: dataArrays.sl_20,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		{
			label: 'SL 30',
			data: dataArrays.sl_30,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
	];

	// Excel verilerini oluşturalım
	const excelData = labels.map((label, i) => ({
		[t('label')]: label,
		[t('totalOpenedAllC')]: dataArrays.opened[i],
		[t('totalWaitingAllC')]: dataArrays.waiting[i],
		[t('totalContacted')]: dataArrays.contacted[i],
		[t('dontConnecttedDescription')]: dataArrays.missing[i],
		[t('totalClosed')]: dataArrays.closed[i],
		['SL ortalama süresi']: dataArrays.agentFirstResponseTimeAfterActivate[i],
		['SL 20']: dataArrays.sl_20[i],
		['SL 30']: dataArrays.sl_30[i],
	}));

	return { labels, datasets, excelData };
}
function chartDataDayHourly(
	totalWaitingConvDayHourly,
	contactedDataDayHourly,
	totalAgentClosedDataDayHourly,
	totalOpenedConvDayHourly,
	start_date,
	end_date,
	t,
	missing_list,
	agentFirstResponseTimeAfterActivateDataDayHourly,
	formatTime,
	sl_20_hourly,
	sl_30_hourly
) {
	//let startDate = new Date(start_date);
	//let endDate = new Date(end_date);
	//console.log('agentFirstResponseTimeAfterActivateDataDayHourly', agentFirstResponseTimeAfterActivateDataDayHourly);
	let labels = [];
	//var dateArr = getDateArray(startDate, endDate);
	var hourArr = getHourArray();
	labels = hourArr;
	let totalWaitingConvDayHourlyData = [],
		totalOpenedConvDayHourlyData = [],
		totalFirstMessageConvDayHourlyData = [],
		contactedDataDayHourlyLineData = [],
		totalAgentClosedDataDayHourlyLineData = [],
		SL20lineData = [],
		SL30lineData = [],
		agentFirstResponseTimeAfterActivateDataLineData = [],
		missingDataLineData = [],
		twObj,
		oObj,
		fmObj,
		cObj,
		newMisslingObj,
		tcObj,
		toObj,
		sl20obj,
		sl30obj,
		agentFirstResponseTimeAfterActivateObj;
	/* console.log('contactedDataDayHourly2', contactedDataDayHourly); */
	_.map(hourArr, (it, i) => {
		newMisslingObj = _.filter(missing_list, (o) => moment(o.date, 'DD-MM-YYYY HH:mm:ss').hour() === it);
		twObj = _.find(totalWaitingConvDayHourly, (o) => o.hour === it);
		oObj = _.find(totalOpenedConvDayHourly, (o) => o.hour === it);
		//fmObj = _.find(totalFirstMessageConvDayHourly, (o) => o.hour === it);
		cObj = (contactedDataDayHourly && contactedDataDayHourly[i] && _.sumBy(contactedDataDayHourly[i], 'count')) || 0;
		tcObj = (totalAgentClosedDataDayHourly && totalAgentClosedDataDayHourly[i] && _.sumBy(totalAgentClosedDataDayHourly[i], 'count')) || 0;
		agentFirstResponseTimeAfterActivateObj = _.find(agentFirstResponseTimeAfterActivateDataDayHourly, (o) => o.hour === it);
		sl20obj = (sl_20_hourly && sl_20_hourly[i] && sl_20_hourly[i].count) || 0;
		sl30obj = (sl_30_hourly && sl_30_hourly[i] && sl_30_hourly[i].count) || 0;
		//console.log('agentFirstResponseTimeAfterActivateObj', agentFirstResponseTimeAfterActivateObj);
		totalWaitingConvDayHourlyData.push((twObj && twObj.count) || 0);
		agentFirstResponseTimeAfterActivateDataLineData.push(
			(agentFirstResponseTimeAfterActivateObj && agentFirstResponseTimeAfterActivateObj.avg && formatTime(agentFirstResponseTimeAfterActivateObj.avg)) ||
				'-'
		);
		totalOpenedConvDayHourlyData.push((oObj && oObj.count) || 0);
		totalFirstMessageConvDayHourlyData.push((fmObj && fmObj.count) || 0);
		contactedDataDayHourlyLineData.push(cObj || 0);
		totalAgentClosedDataDayHourlyLineData.push(tcObj || 0);
		SL20lineData.push(sl20obj || 0);
		SL30lineData.push(sl30obj || 0);
		missingDataLineData.push((newMisslingObj && newMisslingObj.length) || 0);
	});

	//let missingDataLineData = _.map(totalWaitingConvDayHourlyData, (it, i) => Math.max(it - contactedDataDayHourlyLineData[i], 0));
	//console.log('missingDataLineData', totalWaitingConvDayHourlyData, contactedDataDayHourlyLineData, missingDataLineData);
	let totalWaitingConvLine = {
			label: t('totalWaitingAllC'),
			data: totalWaitingConvDayHourlyData,
			borderColor: 'orange',
			backgroundColor: 'orange',
			fill: false,
		},
		totalOpenedConvLine = {
			label: t('totalOpenedAllC'),
			data: totalOpenedConvDayHourlyData,
			borderColor: 'orange',
			backgroundColor: 'orange',
			fill: false,
		},
		contactedDataLine = {
			label: t('totalContacted'),
			data: contactedDataDayHourlyLineData,
			borderColor: 'blue',
			backgroundColor: 'blue',
			fill: false,
		},
		missingDataLine = {
			label: t('dontConnecttedDescription'),
			data: missingDataLineData,
			borderColor: 'red',
			backgroundColor: 'red',
			fill: false,
		},
		closedDataLine = {
			label: t('totalClosed'),
			data: totalAgentClosedDataDayHourlyLineData,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		agentFirstResponseTimeAfterActivateDataLine = {
			label: 'SL Ortalama Süresi',
			data: agentFirstResponseTimeAfterActivateDataLineData,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		sl20Line = {
			label: 'SL 20',
			data: SL20lineData,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		},
		sl30Line = {
			label: 'SL 30',
			data: SL30lineData,
			borderColor: 'green',
			backgroundColor: 'green',
			fill: false,
		};
	//let datasets = [uniqueUserCountsLine, totalWaitingConvLine, contactedDataLine, closedDataLine];
	let datasets = [totalOpenedConvLine, totalWaitingConvLine, contactedDataLine, missingDataLine, closedDataLine, agentFirstResponseTimeAfterActivateDataLine];
	//let datasets = [totalWaitingConvLine, contactedDataLine, missingDataLine, closedDataLine];
	//console.log('agentFirstResponseTimeAfterActivateDataLine', agentFirstResponseTimeAfterActivateDataLine);
	let excelData = _.map(labels, (it, i) => ({
		[t('label')]: it,
		[t('totalOpenedAllC')]: totalOpenedConvDayHourlyData[i],
		[t('totalWaitingAllC')]: totalWaitingConvDayHourlyData[i],
		[t('totalContacted')]: contactedDataDayHourlyLineData[i],
		[t('dontConnecttedDescription')]: missingDataLineData[i],
		[t('totalClosed')]: totalAgentClosedDataDayHourlyLineData[i],
		['SL Ortalama Süresi']: agentFirstResponseTimeAfterActivateDataLine.data[i],
		['SL 20']: sl20Line.data[i],
		['SL 30']: sl30Line.data[i],
	}));
	return {
		labels,
		datasets,
		excelData,
	};
}

const stateToProps = (state) => ({ access: state.access, location: state.router.location, product: state.product });
export default connect(stateToProps)(withTranslation()(Analytic));
